<template>
  <div>
<section class="content propic">
<div class="container-fluid ">
<div class="row">
<div class="col-md-3" style="top:20px">
<div class="card card-primary card-outline">
<div class="card-body box-profile">
<div class="text-center profileArea">
<img class="profile-user-img img-fluid img-circle myprofile" v-if="allDetailsPic.profile_picture !='' && allDetailsPic.profile_picture !=null" :src="`${allDetailsPic.profile_picture}`" alt="User profile picture">
<img v-if="allDetailsPic.profile_picture =='' || allDetailsPic.profile_picture ==null" src="../../../assets/img/default.png" class="profile-user-img img-responsive img-circle">
  <!-- Button trigger modal for profileEdit-->
  <button data-v-54c6ca9c="" type="button" class="btnbtn-xs" style="border: 0px; color: rgb(91, 173, 43);background-color:white; padding-top:6px" data-toggle= "modal"  data-target="#profileEdit"><i data-v-54c6ca9c="" aria-hidden="true" class="fa fa-pencil"></i>Edit</button></div>
</div>
<my-upload field="image"
        @crop-success="cropSuccess"
        @crop-upload-success="cropUploadSuccess"
        @crop-upload-fail="cropUploadFail"
        v-model="show"
        :width="200"
        :height="200"
        :params="params"
        :headers="headers"
        lang-type="en"
        :noRotate="noRotate"
        :noSquare="noSquare"></my-upload>
<div data-v-54c6ca9c="" class="box-tools myProfiledata" v-for="profileDetails in allDetails" :key="profileDetails">
<h3 class="profile-username text-center userName"><strong>{{profileDetails.first_name}} {{profileDetails.last_name}}</strong></h3>
<label for="Designation" style="color:gray">Designation
</label><p class=""><strong>{{profileDetails.designation}}</strong></p>
<ul class="list-group list-group-unbordered mb-3">
<li class="list-group-item">
<label for="Experience" style="color:gray">Experience</label>
<p class="" ><strong>{{profileDetails.experience}} {{profileDetails.month_of_experience}}</strong></p>
</li>
<li class="list-group-item">
<label for="Rating" style="color:gray">Rating
<p class="text-muted text-center rating">
                          <star-rating
                            class="pull-right star starRating"
                            style="width:100%"
                            :show-rating="false"
                            active-color="#5bad2b"
                            v-bind:increment="1"
                            v-bind:star-size="25"
                            rating ="1"
                            read-only
                          ></star-rating
                        >
                      </p></label></li>
<li class="list-group-item">
<label for="Profile Completed" class="percentage" style="color:gray">Profile Completed        <span v-for="percent in percentage" :key="percent"><strong>{{percent.user_percentage}}</strong></span></label>
<div class="myProgress">
  <progress-bar class="profile"
  :options="options"
  :value="percentage"
/> </div>
<br>
<div class="uniqueId">
  <div><strong><i class="fa fa-envelope-o" aria-hidden="true"></i> - {{profileDetails.user_email}}</strong></div>
  <br>
  <div><strong><i class="fa fa-mobile" style="font-size:24px" aria-hidden="true"></i> - {{profileDetails.mobile_number}} </strong></div>
</div>
</li>
</ul>
</div>
</div>
<div class="card card-primary " style="background-color:white; padding-top:10px">
<div class="card-header">
<h4 class="card-title" style="text-align:center;color:gray"><strong>About Me</strong></h4>
</div>

<div class="card-body">
  <label for=""><strong style="color:gray">Short Intro</strong>
  <div data-v-54c6ca9c="" class="box-tools pull-right" >
    <!-- Button trigger modal for Short Intro -->
    <button data-v-54c6ca9c="" type="button" class="btnbtn-xs" style="border: 0px; color: rgb(91, 173, 43);" data-toggle="modal" data-target="#shortIntro" @click="shortIntroEdit()"><i data-v-54c6ca9c="" aria-hidden="true" class="fa fa-pencil"></i> Edit</button>
  </div>
</label>
<br>
<p>
{{shortIntroData}}
</p>
<hr>                    </div>

</div>
</div>
<div class="col-md-9" style="top:20px">
<div class="card">
<div class="card-header p-2 tabHeader" id="myTopnav">
<ul class="nav nav-pills tabBtn">
<li class="nav-item active"><a id="tabBtnRes" class="nav-link active" href="#activity" data-toggle="tab"><strong class="intexp1"> Work Experience</strong></a></li>
<li class="nav-item"><a id="tabBtnRes" class="nav-link" href="#timeline" data-toggle="tab"><strong class="intexp1"> Skills & Rating</strong></a></li>
<li class="nav-item"><a id="tabBtnRes" class="nav-link" href="#settings" data-toggle="tab"><strong class="intexp1"> Financials </strong></a></li>
<li class="nav-item"><a id="tabBtnRes" class="nav-link" href="#PersonalDetails" data-toggle="tab"><strong class="intexp1"> Personal Details </strong></a></li>
<li class="nav-item"><a id="tabBtnRes" class="nav-link" href="#Settings" data-toggle="tab"><strong class="intexp1"> Settings </strong></a></li>
<!-- <li class="nav-item"><a  class="nav-link icon" href="javascript:void(0);" style="font-size:15px;" @click="myFunction()">&#9776;</a>
</li> -->
</ul>

</div>
<div class="card-body">
<div class="tab-content">
<div class="active tab-pane" id="activity">
<div class="post">
            <div>
              <b-form
                class="register-form exp"
              >
                <div>
                  <div class="form-row workexp">
                    <h3 class="float-left mb-0 ml-3 intexp"><strong style="color:black; padding:0px"> Interviewer Experience</strong></h3>
                    <div>
                      <button type="submit" class="btn costeditbtn" @click.prevent="workExperience()">Save</button></div>
                  </div>
                  <hr />
                  <div class="form-row">
                    <div class="form-group designation">
                      <label for="">Designation</label>
                      <b-form-input
                        type="text"
                        placeholder="Designation*"
                        v-model="form2.designation"
                        :class="{
                          'is-invalid': submitted && $v.form2.designation.$error
                        }"
                      />
                      <div v-if="submitted && $v.form2.designation.$error">
                        <p
                          v-if="!$v.form2.designation.required"
                          class="login-alert-msg error-content"
                        >
                          * Enter the Desingantion
                        </p>
                      </div>
                    </div>
                    <div class="form-row experience">
                      <div>
                        <label for=""
                          >Total Years of Experience</label
                        >
                        <div class="form-group selectyear">
                          <div class="form-select">
                            <select
                              v-model="form2.Experience"
                              class="form-control"
                              @change="getTime($event)"
                              :class="{
                                'is-invalid':
                                  submitted && $v.form2.Experience.$error
                              }"
                            >
                              <option value="" class="text" disabled
                                >Years*</option
                              >
                              <option v-for="get in 30" :key="get"
                                >{{ get }} years</option
                              >
                            </select>
                            <span class="select-icon"
                              ><i class="fa fa-chevron-down"></i
                            ></span>
                          </div>
                          <div v-if=" $v.form2.Experience.$error">
                            <p
                              v-if="!$v.form2.Experience.required"
                              class="login-alert-msg error-content"
                            >
                              * Select year
                            </p>
                          </div>
                        </div>
                        <div class="form-group selectmonth">
                          <div class="form-select">
                            <select
                              v-model="form2.month_of_experience"
                              class="form-control selyear"
                              :class="{
                                'is-invalid':
                                  submitted &&
                                  $v.form2.month_of_experience.$error
                              }"
                            >
                              <option value="" class="text" disabled
                                >Months*</option
                              >
                              <option v-for="get in 12" :key="get"
                                >{{ get }} months</option
                              >
                            </select>
                            <span class="select-icon"
                              ><i class="fa fa-chevron-down"></i
                            ></span>
                          </div>
                          <div
                            v-if="
                              submitted && $v.form2.month_of_experience.$error
                            "
                          >
                            <p
                              v-if="!$v.form2.month_of_experience.required"
                              class="login-alert-msg error-content"
                            >
                              * Select month
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group">
                      <label for="">OrganizationStatus</label>
                      <div class="form-select">
                        <select
                          v-model="form2.organizationStatus"
                          class="form-control"
                          :class="{
                            'is-invalid':
                              submitted && $v.form2.organizationStatus.$error
                          }"
                        >
                          <option value="" class="text"
                            >Current Status*</option
                          >
                          <option> Employed </option>
                          <option>Unemployed</option>
                          <option>Self Employed</option>
                        </select>
                        <span class="select-icon"
                          ><i class="fa fa-chevron-down"></i
                        ></span>
                      </div>
                      <div
                        v-if="submitted && $v.form2.organizationStatus.$error"
                      >
                        <p
                          v-if="!$v.form2.organizationStatus.required"
                          class="login-alert-msg error-content"
                        >
                          * Select your Current Status
                        </p>
                      </div>
                    </div>
                    <div class="form-group  org">
                      <label for="">Current Organization</label>
                      <b-form-input
                        type="text"
                        placeholder="Current Organization*"
                        v-model="form2.current_user_organization"
                        :class="{
                          'is-invalid':
                            submitted &&
                            $v.form2.current_user_organization.$error
                        }"
                      />
                      <div
                        v-if="
                          submitted && $v.form2.current_user_organization.$error
                        "
                      >
                        <p
                          v-if="!$v.form2.current_user_organization.required"
                          class="login-alert-msg error-content"
                        >
                          * Enter Current Status
                        </p>
                      </div>
                      <br />
                      <div class="term">
                        <input type="checkbox" style="width:10%" /><label
                          class="currentemp"
                          >Hide current employer</label
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </b-form>
            </div>
</div>
</div>
<div class="tab-pane" id="timeline">
<div class="skillset">
<div>
              <b-form
                class="register-form intskill"
                novalidate
                style="min-height: 500px;"
              >
                <div>
                  <div class="form-row nxtbtn">
                    <h3 class="float-left mb-0 ml-3 intexp"><strong>Interviewer Skills</strong></h3>
                     <button type="button" class="btn btn-success btn-md pull-right addbtn" style="margin-top: -15px;" @click="interviewerSkills()">
                      ADD
                    </button>
                  </div>
                  <hr />
                  <div class="form-row">
                    <div class="row">
                      <div class="col-md-4" id="time">
                        <select
                          name="time"
                          v-model="form.skill_desc"
                          class="sttime"
                          :class="{
                            'is-invalid': submittedtwo && $v.form.skill_desc.$error
                          }"
                          id="time"
                          @change="F($event)"
                        >
                          <option value="">Add Skills</option>
                          <option
                            v-for="get in skills"
                            :key="get.name"
                            :value="get.name"
                            >{{ get.name }}</option
                          >
                        </select>
                        <div v-if="$v.form.skill_desc.$error && submittedtwo">
                          <p v-if="!$v.form.skill_desc.required" class="login-alert-msg error-content">
                            *Skills is required
                          </p>
                        </div>
                        <p v-if="skillexpired">* Skill already added</p>
                      </div>
                    <!-- </div>
                    <div class="row"> -->
                      <div class="col-md-3">
                        <span
                          class="direct-chat-timestamp f12 "
                          >Skill Rating
                          <star-rating
                            v-model="form.self_rating"
                            class="star"
                            style="width:100%"
                            :show-rating="false"
                            active-color="#5bad2b"
                            v-bind:increment="1"
                            v-bind:star-size="25"
                            rating ="1"
                          ></star-rating
                        ></span>
                      </div>
                      <!-- <div class="experience"></div> -->
                    <div class="col-md-5">
                      <div class="col-md-6">
                        <div class="form-select">
                          <select
                            v-model="form.yearofexperience"
                            class="form-control"
                            @change="getTime($event)"
                            :class="{
                              'is-invalid':
                                submittedtwo && $v.form.yearofexperience.$error
                            }"
                          >
                            <option value="" class="text" disabled
                              >Years*</option
                            >
                            <option v-for="get in 30" :key="get"
                              >{{ get }} years</option
                            >
                          </select>
                          <span class="select-icon"
                            ><i class="fa fa-chevron-down"></i
                          ></span>
                        </div>
                        <div v-if="$v.form.yearofexperience.$error && submittedtwo">
                          <p
                            v-if="!$v.form.yearofexperience.required"
                            class="login-alert-msg error-content"
                          >
                            * Select year
                          </p>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-select">
                          <select
                            v-model="form.monthofexperience"
                            class="form-control"
                            :class="{
                              'is-invalid':
                                submittedtwo && $v.form.monthofexperience.$error
                            }"
                            >
                            <option value="" class="text" disabled
                              >Months*</option
                            >
                            <option v-for="get in 12" :key="get"
                              >{{ get }} months</option
                            >
                          </select>
                          <span class="select-icon"
                            ><i class="fa fa-chevron-down"></i
                          ></span>
                        </div>
                        <div v-if="$v.form.monthofexperience.$error && submittedtwo">
                          <p
                            v-if="!$v.form.monthofexperience.required"
                            class="login-alert-msg error-content"
                          >
                            * Select month
                          </p>
                        </div>
                      </div>
                    </div>
                    </div>
                  </div>
                  <br />
                  <hr v-if="userSkills.length > 0">
                  <div class="lists" v-if="userSkills.length > 0">
                    <h3 class="tc intexp">My Skillset</h3>
                    <table id="customers">
                      <tr>
                        <th>Skill</th>
                        <th>Self Rating</th>
                        <th>Years of Experience</th>
                        <th>Action</th>
                      </tr>
                      <tr v-for="(skill, index) in userSkills" :key="index">
                        <td>{{ skill.skill_desc }}</td>
                        <td>{{ skill.self_rating }}</td>
                        <td>
                          {{ skill.yearofexperience }}
                          {{ skill.monthofexperience }}
                        </td>
                        <td>
                          <a @click="tempSkill(skill, index)"
                            class="btn button-default"
                            id="skilldeletebtn"
                            style="background:none;color:red"
                            type="button"
                            data-toggle="modal" data-target="#deleteModal"
                            >Delete</a
                          >
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </b-form>
            </div>
<div>
<!-- <i class="far fa-clock bg-gray"></i> -->
</div>
</div>
</div>
<div class="tab-pane" id="settings">
<div class="container">
<div class="form-row nextbtn">
                    <h3 class="float-left mb-0 ml-3 intexp"><strong>Interviewer Cost</strong></h3>
                  </div>
                  <hr>
                  <div class="Intcost" v-for="cost in allDetails" :key="cost">
                    <label for="">Interview cost mentioned by you</label>
                  <div class="editcost">₹ {{cost.interview_cost}} <button data-toggle="modal"
                          data-target="#editcostbtn" class="btn editcostbtn"  @click="editCost()">Edit Cost</button></div>
                  </div>
                  <br>
                  <br>
                  <div class="accards">
                  <div class="financialcard"><button class="btn accbtn" @click="accDetails()"><i style="padding-bottom:10px" class="fa fa-bank fa-4x"></i><br> <strong class="cardname">Account Details</strong></button></div>
                  <div class="financialcard" @click="walletDetails()"><button class="btn accbtn"><i style="padding-bottom:5px" class="fa fa-google-wallet fa-4x"></i><br><strong class="cardname" >My Wallet</strong></button></div>
                  <div class="financialcard" @click="statDetails()"><button class="btn accbtn"><i  style="padding-bottom:5px" class="fa fa-line-chart fa-4x"></i><br><strong class="cardname">Interview Stats</strong></button></div>
                  </div>
                  <br>
                  <br>
                  <!-- Account Detials page  -->
                  <div class="BankDetials" v-show="!accountdetails">
                    <div class="accountpage"><h3 class="intexp"><strong>Bank Account</strong></h3>
                    <div class="bankaccount">Saved Bank Details<button data-toggle="modal"
                          data-target="#addBankbtn" class="btn addBankbtn" @click="addAccountPopUp()"><i class="fa fa-plus-circle" aria-hidden="true"></i> A/C</button></div>
                          <br>
                          <br>
                          <div class="MyBank" >
                            <div class="MyBankData" v-for="(myBankdatas,_id) in getBankData" :key="_id"><div class="mybankIcon"><i style="padding-bottom:5px;color:#5bad2b" class="fa fa-bank fa-2x"></i><strong style="padding-left:10px" class="bankname">{{myBankdatas.bank_name}}</strong>
                            </div>
                            <div class="accnumber"><strong>A/c No - {{myBankdatas.accno}}</strong></div>
                            <div class="myBankBtn">
                            <button class="btn editBankbtn" data-toggle="modal"
                          data-target="#editBankbtn" @click="editmyBankdata(_id)"><i class="fa fa-pencil" aria-hidden="true"></i></button>
                          <button class="btn deleteAcc"
                           @click="deleteBank(_id)">
<i class="fa fa-trash-o" aria-hidden="true"></i>
</button></div></div>
                            <!-- <div>{{bankAccount}}</div> -->
                          </div>
                          </div>
                  </div>
<br>
<br>
                  <!-- my wallet page  -->
                   <div class="Mywallet" v-show="isHidden">
                    <div class="accountpage"><h3 class="intexp">My Wallet</h3>
                    <div class="wallet"><div><i class="fa fa-google-wallet fa-2x"></i> <strong style="padding-left:15px;font-size:20px">IAC </strong><i class="fa fa-question-circle" aria-hidden="true"></i></div><div class="amount"><strong> ₹ {{iacWalletData[0].coalesce}}</strong></div> </div></div>
                    <br>
                    <!-- <div class="WalletBal"><div class="walbal">Wallet Balance <strong>₹ 100</strong></div> <div><button class="btn withdrawbtn">Withdraw</button></div></div> -->
                    <div class="WalletBal"><div class="walbal">Wallet Balance <strong>₹ {{getWalletData.balance_amount}}</strong></div> <div><button class="btn withdrawbtn" data-toggle="modal" data-target="#withdraw">Withdraw</button></div></div>
                  <br>
<div class="card-header p-2 tabHeader">
<ul class="nav nav-pills tabBtn">
<!-- <li class="nav-item"><a id="tabBtnRes" class="nav-link active" href="#earnedAmt" data-toggle="tab"><strong class="intexp1"> Amount Earned </strong></a></li> -->
<li class="nav-item active"><a id="tabBtnRes" class="nav-link active" href="#earnedAmt " data-toggle="tab"><strong class="intexp1"> Amount Earned </strong></a></li>
<li class="nav-item"><a id="tabBtnRes" class="nav-link" href="#withdraAmt" data-toggle="tab"><strong class="intexp1">Amount Withdrawn</strong></a></li>
</ul>
</div>
<div class="card-body">
<div class="tab-content">
<div class="tab-pane active" id="earnedAmt">
  <div class="container">
  <div class="WalletBal"><h4>Amount Earned</h4><div><strong style="font-size:20px"> ₹ {{getWalletData.total_amount_earned}}</strong> </div></div>
  <hr>
  <div><h3>Detailed Transactions</h3>
</div>
  <div class="Transactions" v-for="(mytransaction, index) in otherEarnedHistory" :key="index">
<div ><h3 class="trans">{{mytransaction.date}}</h3></div>
<!-- <div class="transdata" v-for="(mylist, index1) in mytransaction.listdetail " :key="index1"> <div>{{mylist.created_at}}</div> <div>{{mylist.organization_name}}</div> <div>{{mylist.job_title}}</div><div>{{mylist.earned_transaction_id}}</div> <div>{{mylist.amount}}</div></div> -->
<br>
<table class="myTransTable">
  <tr class="tableheader">
    <th>DATE</th>
<th>COMPANY NAME</th>
<th>INTERVIEW</th>
<th>TRANSACTION ID</th>
<th>CREDITED AMOUNT</th>
  </tr>
  <tr v-for="(mylist, index1) in mytransaction.listdetail " :key="index1">
    <td>{{mylist.created_at}}</td>
    <td>{{mylist.organization_name}}</td>
    <td>{{mylist.job_title}}</td>
    <td>{{mylist.earned_transaction_id}}</td>
    <td style="color:#5abd2b" >+ ₹ {{mylist.amount}}</td>
  </tr>
</table>
  </div>
  <hr>
</div>
</div>
<div class="tab-pane" id="withdraAmt">
<div class="container">
  <div class="WalletBal"><h4>Total Amount Withdrawn</h4>  <div><strong style="font-size:20px">₹ {{getWalletData.total_amount_withdrawn}}</strong></div></div>
</div>
</div>
</div>
</div>
</div>
<br>
                  <!-- Interview Stats page  -->
                  <div class="BankDetials" v-show="stats">
                    <div class="accountpage"><h3 class="intexp"><strong>Interview Stats</strong></h3>
                    <div class="bankaccount">Total Interview Conducted</div></div>
                  <br><br>
                    <hr>
                    <div class="form-row intstats" >
                      <div class="form-group">
                        <label for="" class="completed"><i class="fa fa-calendar-check-o fa-3x successicon" aria-hidden="true" ></i><h4 class="intcom">Interview Completed</h4> <div><strong style="font-size:20px">{{IntStats.interview_completed_count}}</strong></div></label>
                        <!-- <input type="text" class="form-control" id="postTitle" placeholder="Enter Post Title"> -->
                      </div>
                      <div class="form-group">
                        <label for="" class="completed"><i class="fa fa-calendar-times-o fa-3x closeicon" aria-hidden="true"></i><h4 class="intincom">Interview InComplete</h4> <strong style="font-size:20px">{{IntStats.interview_incompleted_count}}</strong></label>
                        <!-- <input type="text" class="form-control" id="postTitle" placeholder="Enter Post Title"> -->
                      </div>
                    </div>
                  <div>Post Activities
                    <hr>
                    <br>
<div class="panel-group" id="accordion" role="tablist"  aria-multiselectable="true" >
  <div class=" panel panel-default">
    <div class="panel-heading mypadding" role="tab" id="headingOne">
      <h4 class="panel-title">
        <a role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="true" aria-controls="collapseOne" class="Statsheading">
<h4 class="iconsEdit"><i class="fa fa-arrow-up fa-2x successicon" aria-hidden="true"></i><strong class="intstatistics">Interest Requested</strong></h4><div style="font-size:16px"><strong>1</strong></div></a>

      </h4>
    </div>
    <div id="collapseOne" class="panel-collapse collapse in" role="tabpanel" aria-labelledby="headingOne">
      <div class="panel-body">
                <div class="accHeadtwo">Detailed View</div>

       <div class="form-row ">
         <div class="form-group"><div class="accone">
         <div><h5><i class="fa fa-arrow-circle-o-up fa-2x requesticon" aria-hidden="true"></i> <strong style="font-size:20px padding:5px">Interest Sent</strong></h5>
</div>
         <div style="font-size:16px"><strong>{{IntStats.interest_sent
}}</strong></div>

       </div></div>
         <div class="form-group"><div class="accone">
         <div><h5><i class="fa fa-arrow-circle-o-down fa-2x requesticon" aria-hidden="true"></i> <strong style="font-size:20px padding:5px">Interest Received</strong></h5>
</div>
         <div style="font-size:16px"><strong>{{IntStats.interest_receive}}</strong></div>
       </div></div>
       </div>
      </div>
    </div>
  </div>
  <div class=" panel panel-default">
    <div class="panel-heading mypadding" role="tab" id="headingTwo">
      <h4 class="panel-title">
      <a class="collapsed Statsheading" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo"><h4 class="iconsEdit"><i class="fa fa-thumbs-o-up fa-2x successicon" aria-hidden="true"></i><strong class="intstatistics">Interest Accepted</strong></h4><div style="font-size:16px"><strong>1</strong></div></a>
      </h4>
    </div>
    <div id="collapseTwo" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingTwo">
      <div class="panel-body">
       <div class="accHeadtwo">Detailed View</div>

       <div class="form-row ">
         <div class="form-group"><div class="accone">
         <div><h5><i class="fa fa-user fa-2x requesticon" aria-hidden="true"></i>
<strong style="font-size:20px padding:5px">Accepted by you</strong></h5>
</div>
         <div style="font-size:16px"><strong>{{IntStats.interest_accepted_by_you}}</strong></div>

       </div></div>
         <div class="form-group"><div class="accone">
         <div><h5><i class="fa fa-user-o fa-2x requesticon" aria-hidden="true"></i> <strong style="font-size:20px padding:5px">Accepted by Organization</strong></h5>
</div>
         <div style="font-size:16px"><strong>{{IntStats.interest_accepted_by_org}}</strong></div>
       </div></div>
       </div>
      </div>
    </div>
  </div>
  <div class="panel panel-default">
    <div class="panel-heading mypadding" role="tab" id="headingThree">
      <h4 class="panel-title">
        <a class="collapsed Statsheading" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
<h4 class="iconsEdit"><i class="fa fa-window-close fa-2x declineicon" aria-hidden="true"></i><strong class="intstatistics">Interest Cancelled </strong></h4>   <div style="font-size:16px"><strong>1</strong></div>    </a>
      </h4>
    </div>
    <div id="collapseThree" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingThree">
      <div class="panel-body">
       <div class="accHeadtwo">Detailed View</div>

       <div class="form-row ">
         <div class="form-group"><div class="accone">
         <div><h5><i class="fa fa-user fa-2x requesticon" aria-hidden="true"></i> <strong style="font-size:20px padding:5px">Cancelled by you</strong></h5>
</div>
         <div style="font-size:16px"><strong>{{IntStats.interest_cancelled_by_you}}</strong></div>

       </div></div>
         <div class="form-group"><div class="accone">
         <div><h5><i class="fa fa-user-o fa-2x requesticon" aria-hidden="true"></i> <strong style="font-size:20px padding:5px">Cancelled by Organization</strong></h5>
</div>
         <div style="font-size:16px"><strong>{{IntStats.interest_cancelled_by_org}}</strong></div>
       </div>
       </div>
       </div>
      </div>
    </div>
  </div>
<div class="panel panel-default">
    <div class="panel-heading mypadding" role="tab" id="headingFour">
      <h4 class="panel-title">
        <a class="collapsed Statsheading" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
<h4 class="iconsEdit"><i class="fa fa-thumbs-o-down fa-2x declineicon" aria-hidden="true"></i><strong class="intstatistics">Interest Declined</strong>
</h4><div style="font-size:16px"><strong>1</strong>
</div>
 </a>
      </h4>
    </div>
    <div id="collapseFour" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingFour">
      <div class="panel-body">
       <div class="accHeadtwo">Detailed View</div>

       <div class="form-row ">
         <div class="form-group"><div class="accone">
         <div><h5><i class="fa fa-user fa-2x requesticon" aria-hidden="true"></i> <strong style="font-size:20px padding:5px">Declined by you</strong></h5>
</div>
         <div style="font-size:16px"><strong>{{IntStats.interest_declined_by_you}}</strong></div>

       </div></div>
         <div class="form-group"><div class="accone">
         <div><h5><i class="fa fa-user-o fa-2x requesticon" aria-hidden="true"></i> <strong style="font-size:20px padding:5px">Declined by Organization</strong></h5>
</div>
         <div style="font-size:16px"><strong>{{IntStats.interest_declined_by_org}}</strong></div>

       </div></div>
       </div>
      </div>
    </div>
  </div>
  <div class="panel panel-default">
    <div class="panel-heading mypadding" role="tab" id="headingFive">
      <h4 class="panel-title">
        <a class="collapsed Statsheading" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
<h4 class="iconsEdit"><i class="fa fa-calendar-plus-o fa-2x successicon" aria-hidden="true"></i><strong class="intstatistics">Interviews Scheduled</strong> </h4><div style="font-size:16px"><strong>1</strong></div></a>
      </h4>
    </div>
    <div id="collapseFive" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingFive">
      <div class="panel-body">
        <div class="accone">
         <div><h5><i class="fa fa-calendar-plus-o fa-2x successicon" aria-hidden="true"></i> <strong style="font-size:20px padding:5px">Interest Scheduled</strong></h5>
</div><div style="font-size:16px"><strong>{{IntStats.interview_schedule_count}}</strong></div>
       </div>
       <!-- <div class="accHeadtwo">Detailed View</div> -->

       <!-- <div class="form-row ">
         <div class="form-group"><div class="accone">
         <div><h5><i class="fa fa-arrow-circle-o-up fa-2x requesticon" aria-hidden="true"></i> <strong style="font-size:20px padding:5px">Interest Sent</strong></h5>
</div>
         <div style="font-size:16px"><strong>1</strong></div>

       </div></div>
         <div class="form-group"><div class="accone">
         <div><h5><i class="fa fa-arrow-circle-o-up fa-2x requesticon" aria-hidden="true"></i> <strong style="font-size:20px padding:5px">Interest Received</strong></h5>
</div>
         <div style="font-size:16px"><strong>1</strong></div>

       </div></div>
       </div> -->
      </div>
    </div>
  </div>
  <div class=" panel panel-default">
    <div class="panel-heading mypadding" role="tab" id="headingSix">
      <h4 class="panel-title">
        <a class="collapsed Statsheading" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
<h4 class="iconsEdit"><i class="fa fa-calendar fa-2x successicon" aria-hidden="true"></i><strong class="intstatistics">Interviews Rescheduled</strong> </h4>   <div style="font-size:16px"><strong>1</strong></div>    </a>
      </h4>
    </div>
    <div id="collapseSix" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingSix">
      <div class="panel-body">
        <!-- <div class="accone">
         <div><h5><i class="fa fa-arrow-circle-o-up fa-2x requesticon" aria-hidden="true"></i> <strong style="font-size:20px padding:5px">Interviews Rescheduled</strong></h5>
       </div><div style="font-size:16px"><strong>1</strong></div>
       </div> -->
       <div class="accHeadtwo">Detailed View</div>

        <div class="form-row ">
         <div class="form-group"><div class="accone">
         <div><h5><i class="fa fa-arrow-circle-o-up fa-2x requesticon" aria-hidden="true"></i> <strong style="font-size:20px padding:5px">Reschedule Request Sent</strong></h5>
</div>
         <div style="font-size:16px"><strong>{{IntStats.reschedule_req_sent}}</strong></div>
         </div></div>
         <div class="form-group"><div class="accone">
         <div><h5><i class="fa fa-arrow-circle-o-down fa-2x requesticon" aria-hidden="true"></i> <strong style="font-size:20px padding:5px">Reschedule Request Received</strong></h5>
</div>
      <div style="font-size:16px"><strong>{{IntStats.reschedule_req_received}}</strong></div>
      </div></div>
      </div>
      <div class="form-row ">
         <div class="form-group"><div class="accone">
         <div><h5><i class="fa fa-user fa-2x requesticon" aria-hidden="true"></i> <strong style="font-size:20px padding:5px">Reschedule Accepted by You</strong></h5>
</div>
         <div style="font-size:16px"><strong>{{IntStats.reschedule_accept_by_you}}</strong></div>
         </div></div>
         <div class="form-group"><div class="accone">
         <div><h5><i class="fa fa-user-o fa-2x requesticon" aria-hidden="true"></i> <strong style="font-size:20px padding:5px">Reschedule Accepted by Organization</strong></h5>
</div>
      <div style="font-size:16px"><strong>{{IntStats.reschedule_accept_by_org}}</strong></div>
      </div></div>
      </div>
      <div class="form-row ">
         <div class="form-group"><div class="accone">
         <div><h5><i class=" fa fa-window-close fa-2x declineicon" aria-hidden="true"></i> <strong style="font-size:20px padding:5px" class="intexp">Reschedule Cancelled</strong></h5>
</div>
         <div style="font-size:16px"><strong>{{IntStats.reschedule_cancelled}}</strong></div>
         </div></div>
         <div class="form-group"><div class="accone">
         <div><h5><i class="fa fa-thumbs-o-down fa-2x declineicon" aria-hidden="true"></i> <strong style="font-size:20px padding:5px">Reschedule Declined</strong></h5>
</div>
      <div style="font-size:16px"><strong>{{IntStats.reschedule_declined}}</strong></div>
      </div></div>
      </div>
      </div>
    </div>
  </div>
  <div class=" panel panel-default">
    <div class="panel-heading mypadding" role="tab" id="headingSeven">
      <h4 class="panel-title">
        <a class="collapsed Statsheading" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
<h4 class="iconsEdit"><i class="fa fa-calendar-times-o fa-2x declineicon" aria-hidden="true"></i><strong class="intstatistics">Interviews Cancelled</strong> </h4>  <div style="font-size:16px"><strong>1</strong></div></a>
      </h4>
    </div>
    <div id="collapseSeven" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingSeven">
      <div class="panel-body">
        <!-- <div class="accone">
         <div><h5><i class="fa fa-arrow-circle-o-up fa-2x requesticon" aria-hidden="true"></i> <strong style="font-size:20px padding:5px">Interest Requested</strong></h5>
</div>
       </div> -->
       <div class="accHeadtwo">Detailed View</div>

       <div class="form-row ">
         <div class="form-group"><div class="accone">
         <div><h5><i class="fa fa-user fa-2x requesticon" aria-hidden="true"></i><strong style="font-size:20px padding:5px">Cancelled by You</strong></h5>
</div>
         <div style="font-size:16px"><strong>{{IntStats.interview_cancelled_by_you}}</strong></div>

       </div></div>
         <div class="form-group"><div class="accone">
         <div><h5><i class="fa fa-user-o fa-2x requesticon" aria-hidden="true"></i><strong style="font-size:20px padding:5px">Cancelled by Organization</strong></h5>
         </div>
         <div style="font-size:16px"><strong>{{IntStats.interview_cancelled_by_org}}</strong></div>
       </div></div>
       </div>
      </div>
    </div>
    </div>
  </div>
</div>
</div>
</div>
</div>
<div class="tab-pane" id="PersonalDetails">
<div class="form-body container" style="background-color:#ffffff">
        <div class="form">
                <b-form
                  class="register-form"
                  novalidate
                  style="background-color: #ffffff;"
                >
                  <div>
                    <br />
                    <div class="skip">
                      <h3 class="float-left titleheader"><strong>Resume & Video Upload</strong></h3>
                    </div>
                    <hr />
                    <div class="form-row skills">
                      <div class="UserUpload">
                        <div class="form-group">
                          <label>Video Attachment</label>
                          <div class="custom-file-upload">
                            <div v-if="video.length < 1" class="show-doc-empty">
                              Select the File
                            </div>
                            <div class="show-doc" v-if="video.length > 0">
                              <span
                                class="doc-file pull-left"
                                v-for="x in video.slice(0, 2)"
                                :key="x"
                                ><span class="doc-name">{{ x.name }} </span
                                ><i
                                  @click="removeVideo(x)"
                                  class="fa fa-times"
                                  style="color: #ccc;"
                                  aria-hidden="true"
                                ></i
                              ></span>
                            </div>
                            <label for="video"
                              ><i class="uil uil-upload" aria-hidden="true"></i> Upload
                            </label>
                            <input
                              @change="videoUpload($event)"
                              style="visibility: hidden;"
                              type="file"
                              id="video"
                              accept="video/*"
                              name="myfiles[]"
                              multiple
                            />
                          </div>
                          <p style="color: #aeaaaa;margin: 3px 0 10px;">
                            Supported format (.mp4), Size (Max 10MB)
                          </p>
                          <span v-if="videoErrorShow" class="error-msg">* Please select the video</span>
                          <div><video class="mt-2" id="video-preview" controls style="width: 300px;"></video></div>
                        </div>
                      </div>
                    </div>
                    <div class="form-row skills">
                      <div class="UserUpload">
                        <div class="form-group">
                          <label>Attachment</label>
                          <div class="custom-file-upload">
                            <div v-if="files.length < 1" class="show-doc-empty">
                              Select the File
                            </div>
                            <div class="show-doc" v-if="files.length > 0">
                              <span
                                class="doc-file pull-left"
                                v-for="x in files.slice(0, 2)"
                                :key="x"
                                ><span class="doc-name">{{ x.name }} </span
                                ><i
                                  @click="removeUploading(x)"
                                  class="fa fa-times"
                                  style="color: #ccc;"
                                  aria-hidden="true"
                                ></i
                              ></span>
                            </div>
                            <label for="file"
                              ><i class="uil uil-upload" aria-hidden="true"></i> Upload
                            </label>
                            <input
                              @change="fileUpload($event)"
                              style="visibility: hidden;"
                              type="file"
                              id="file"
                              name="myfiles[]"
                              multiple
                            />
                          </div>
                          <p style="color: #aeaaaa;margin: 3px 0 10px;">
                            Supported format (.pdf, .doc, .docx), Size (Max 2MB)
                          </p>
                          <span v-if="fileErrorShow" class="error-msg">* Please select the file</span>
                        </div>
                      </div>
                    </div>
                    <div class="form-col">
                      <div class="form-group" style="display:flex;justify-content:center">
                        <button type="button" class="btn btn-success btn-md UploadBtn" @click="uploadAttachment()"
                        >
                          SUBMIT
                        </button>
                      </div>
                    </div>
                  </div>
                </b-form>
              </div>
  </div>
</div>
<div class="tab-pane" id="Settings">
<div class="form-body container" style="background-color:#ffffff">
  <!-- <div class="changePassword"><h4 class="iconsEdit">
    <i class="fa fa-lock fa-2x successicon" aria-hidden="true"></i><strong class="intexp">Change Password</strong></h4>  </div> -->
    <div class="changePassword"><h4 class="iconsEdit">
    <i class="fa fa-lock fa-2x successicon" aria-hidden="true"></i><strong class="intexp">Change Password</strong></h4></div>

    <br>
    <form
            @submit.prevent="changePassword()"
            novalidate
            method="post"
            class="changemyPassword"
          >
          <div class="changemypswd" >
          <div class="form-group">
              <input
                :type="passwordFieldType2"
                class="form-control"
                placeholder="Enter CurrentPassword"
                value=""
                v-model="form.oldpassword"
                autocomplete="off"
              />
              <span
                class="uil uil-eye form-control-feedback"
                v-if="passwordFieldType2 == 'text'"
                @click="switchVisibility2"
              ></span>
              <span
                class="uil uil-eye-slash form-control-feedback"
                v-if="passwordFieldType2 == 'password'"
                @click="switchVisibility2"
              ></span>
              <p style="font-size: 11px" class="error-msg" v-if="$v.form.oldpassword.required && !chkState('oldpassword')">
                <span>* Must have 8 characters with 1 upper case letter, 1 number & 1 special character</span></p>
              <div
                v-if="this.submitted && $v.form.oldpassword.$error"
                class="invalid-feedback left"
              >
                <span v-if="!$v.form.oldpassword.required"
                  >Current Password is required</span
                >
              </div>
            </div>
            <div class="form-group">
              <input
                :type="passwordFieldType"
                class="form-control"
                placeholder="Enter Password"
                value=""
                v-model="form.newpassword"
                autocomplete="off"
              />
              <p style="font-size: 11px" class="error-msg" v-if="$v.form.newpassword.required && !chkState('newpassword')">
                <span>* Must have 8 characters with 1 upper case letter, 1 number & 1 special character</span></p>
              <div
                v-if="this.submitted && $v.form.newpassword.$error"
                class="invalid-feedback left"
              >
                <span v-if="!$v.form.newpassword.required"
                  >Password is required</span
                >
              </div>
            </div>
            <div class="form-group">
              <input
                :type="passwordFieldType1"
                class="form-control"
                placeholder="Confirm Password"
                value=""
                v-model="form.confirmPassword"
                autocomplete="off"
              />
              <span
                class="uil uil-eye form-control-feedback"
                v-if="passwordFieldType1 == 'text'"
                @click="switchVisibility1"
              ></span>
              <span
                class="uil uil-eye-slash form-control-feedback"
                v-if="passwordFieldType1 == 'password'"
                @click="switchVisibility1"
              ></span>
              <div
                v-if="this.submitted && $v.form.confirmPassword.$error"
                class="invalid-feedback left"
              >
                <span v-if="!$v.form.confirmPassword.required"
                  >Confirm Password is required</span
                >
                <span
                  v-if="
                    form.confirmPassword &&
                      !$v.form.confirmPassword.sameAsPassword
                  "
                  >Password and Confirm Password should match</span
                >
              </div>
            </div>
            <br />
            <input
              type="submit"
              class="btnRegister"
              value="Save"
            /></div>
          </form>
</div>
</div>
</div>
</div>
</div>
</div>
<!-- modal for withdraw money  -->
<div class="modal fade" id="withdraw" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4
                                  class="modal-title closebtnmodel"
                                  id="exampleModalLabel"
                                >
                                   <strong>Withdraw</strong>
                                   <button
                                  type="button"
                                  class="close icon"
                                  data-dismiss="modal"
                                  aria-label="Close"
                                >
                                  <span aria-hidden="true">&times;</span>
                                </button>
                                </h4>
                                </div>
      <div class="modal-body">
        <div>Enter the amount to be transferred from your wallet into your account</div>
        <div><label for="">Amount</label>
        <input v-model="withdraw_amount" type="text" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"></div>
        <br>
        <!-- <div><label for="">Account Number</label>
        <input type="text" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"></div> -->
        <div><label for="">Bank Account</label>
        <p>
  <button class="btn btn-success" type="button" data-toggle="collapse" data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
   <i class="fa fa-plus" aria-hidden="true"></i> Choose Your Bank
  </button>
</p>
<div class="main-container">
<div class="collapse" id="collapseExample">
  <div class="card cardbody">
    <div class="radio-buttons">
      <ul class="choosebank" v-for="(myBankdatas,_id) in getBankData" :key="_id">
        <li>
        <label class="custom-radio">
          <input type="radio" name="radio" />
          <span class="radio-btn" @click="setBankData(_id)">
            <i class="fa fa-check" aria-hidden="true"></i>
            <div class="hobbies-icon">
<i class="fa fa-bank fa-2x"></i>
 <p class="mybankname">{{myBankdatas.bank_name}}
  <span>{{myBankdatas.accno}}</span>
</p>
            </div>
          </span>
        </label>
        </li>
        </ul>
      </div>
  </div>
</div>
</div>
    </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        <button type="button" class="btn transfer" @click="transferMoney()">Transfer</button>
      </div>
    </div>
  </div>
</div>
<!-- Modal for #profileEdit -->
<div class="modal fade" id="profileEdit" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title closebtnmodel " id="exampleModalLabel"><strong>Personal Details </strong><button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button></h4>
      </div>
      <div class="modal-body">
        <div class="container">
              <form
                class="register-form"
                novalidate
                style="background-color: #ffffff;padding: 20px;"
              >
                <div v-for="list of allDetails" :key="list">
                  <!-- <div class="form-row">
                    <h4 class="float-left mb-0 ml-3">Personal Details</h4>
                  </div> -->
                  <div class="box-body box-profile">

                  <div class="profileavatar">
                     <img id="editUserAvatar" @click="toggleShow" v-if="allDetailsPic.profile_picture !='' && allDetailsPic.profile_picture !=null" :src="`${allDetailsPic.profile_picture}`" class="profile-user-img img-fluid img-circle ">
                  <img @click="toggleShow" v-if="allDetailsPic.profile_picture =='' || allDetailsPic.profile_picture == null" src="../../../assets/img/default.png">
                  <i aria-hidden="true" @click="toggleShow" class="fa fa-pencil edit-icon myTheme"></i>
                </div>
                    <!-- <img src="https://images.unsplash.com/photo-1525498128493-380d1990a112?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=435&q=80" alt="" class="profile-user-img img-fluid img-circle useravatar"> -->
                  <!-- <div><a class="btn" type="file" @click="toggleShow">Edit</a></div> -->
                  </div>
                  <hr />
                  <div class="form-row">
                    <div class="form-group">
                      <input
                        type="text"
                        placeholder="First Name*"
                        v-model="form.first_name"
                        :class="{ 'is-invalid': submittedthree && $v.form.first_name.$error }"
                      />
                      <div
                  v-if="submittedthree && $v.form.first_name.$error"
                  class="invalid-feedback" style="color:red; font-size:12px;text-align:left;"
                >

                  <span v-if="!$v.form.first_name.required"
                    >First name is required</span
                  >
                  <span v-if="$v.form.first_name.required && !$v.form.first_name.minLength"
                    >First name must be at least 3 characters</span
                  >
                </div>
                    </div>
                    <div class="form-group">
                      <input
                        type="text"
                        placeholder="Last Name*"
                        v-model="form.last_name"
                        :class="{ 'is-invalid': submittedthree && $v.form.last_name.$error }"
                      />
                      <div v-if="submittedthree && $v.form.last_name.$error"
                  class="invalid-feedback"  style="color:red; font-size:12px;text-align:left;"
                >
                  <span v-if="!$v.form.last_name.required"
                    >Last name is required</span
                  >
                  <!-- <span v-if="$v.form.last_name.required && !$v.form.last_name.minLength"
                    >Last name must be at least 3 characters</span
                  > -->
                </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group">
                      <div class="form-select">
                        <select
                          id="orgtype"
                          v-model="form.gender"
                          class="form-control"
                          :class="{ 'is-invalid': submittedthree && $v.form.gender.$error }"
                        >
                          <option value="" class="text" disabled
                            >Select Gender*</option
                          >
                          <option>Male</option>
                          <option>Female</option>
                        </select>
                        <span class="select-icon"
                          ><i class="fa fa-chevron-down"></i
                        ></span>
                      </div>
                      <div
                  v-if="submittedthree && $v.form.gender.$error"
                  class="invalid-feedback" style="color:red;text-align: left "
                >
                  <span v-if="!$v.form.gender.required"  style="color:red; font-size:12px;"
                    >*select your role</span
                  >
                </div>
                    </div>
                    <div class="form-group">
                      <input style="background:lightgrey"
                        type="email"
                        placeholder="Email*"
                        v-model="form.user_email"
                        readonly
                      />
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group">
                      <vue-tel-input
                        class="form-control"
                        placeholder="Mobile Number"
                        v-model="form.mobile_number"
                        @onInput="onInput"
                        v-bind:class="{ 'is-invalid': !isValiedmobileNumber }"
                      ></vue-tel-input>
                      <div v-if="$v.form.mobile_number.$error">
                        <p
                          v-if="!$v.form.mobile_number.required"
                          class="login-alert-msg error-content"
                        >
                          * Enter your mobile number
                        </p>
                        <p
                          v-if="$v.form.mobile_number.required && !$v.form.mobile_number.minLength"
                          class="login-alert-msg error-content"
                        >
                          * Enter a valid mobile number
                        </p>
                      </div>
                    </div>
                    <div class="form-group">
                  <div class="form-select">
                    <select v-model="form.country_name" @change="getState()" class="form-control" v-bind:class="{ 'is-invalid': !chkState('country_name'), 'not-chosen': !form.country_name }">
                      <option value="" class="text" disabled>Country*</option>
                      <option v-for="x in Country" :value="x.name" :key="x.id">{{x.name}}</option>
                    </select>
                    <span class="select-icon"><i class="fa fa-chevron-down"></i></span>
                  </div>
                  <div v-if="$v.form.country_name.$error">
                    <p v-if="!$v.form.country_name.required" class="login-alert-msg error-content">* Select the country</p>
                  </div>
                </div>
                  </div>
                  <div class="form-row">
                  <div class="form-group">
                  <div class="form-select">
                    <select v-model="form.state_name" @change="getCity()" class="form-control" v-bind:class="{ 'is-invalid': !chkState('state_name'), 'not-chosen': !form.state_name }">
                      <option value="" class="text" disabled>State*</option>
                      <option v-for="x in State" :value="x.name" :key="x.id">{{x.name}}</option>
                    </select>
                    <span class="select-icon"><i class="fa fa-chevron-down"></i></span>
                  </div>
                  <div v-if="$v.form.state_name.$error">
                    <p v-if="!$v.form.state_name.required" class="login-alert-msg error-content">* Select the state</p>
                  </div>
                </div>
                </div>
                </div>
              </form>
            </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        <button type="submit" class="btn btn-success btn-md pull-right signupbtn" @click.prevent="onUpdateProfile()">Update</button>
      </div>
    </div>
  </div>
</div>
<!-- Modal for short intro -->
<div class="modal fade" id="shortIntro" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
            <form action="">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title closebtnmodel" id="exampleModalLabel"><strong>Short Intro</strong> <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button></h4>
      </div>
      <div class="modal-body txtarea">
        <textarea  placeholder="Enter short intro about yourself" class="invalid-feedback" name="" id="" cols="100" rows="5" v-model="form1.user_bio" :class="{ 'is-invalid': submittedone && $v.form1.user_bio.$error }"></textarea>
        <div
                  v-if="submittedone && $v.form1.user_bio.$error"
                  class="invalid-feedback" style="color:red; font-size:12px;text-align:left;"
                >
                  <span v-if="!$v.form1.user_bio.required"
                    >Short Intro is required</span
                  >
                  <!-- <span v-if="$v.form1.user_bio.required && !$v.form1.user_bio.minLength"
                    >Short Intro must be at least 50 characters</span
                  > -->
                </div>
      </div>
      <!-- <p style="float:right;padding:4px">Max 200 Characters</p> -->
      <br>
      <div class="modal-footer introBtn">
        <button type="button" class="btn " data-dismiss="modal">Close</button>
        <button type="button" class="btn saveaccdetialsbtn"  v-on:click="shortIntro()">Submit</button>
      </div>
    </div>
    </form>
  </div>
</div>
<!-- Modal  for edit cost-->
                        <div
                          class="modal fade"
                          id="editcostbtn"
                          tabindex="-1"
                          role="dialog"
                          aria-labelledby="exampleModalLabel"
                          aria-hidden="true"
                        >
                          <div class="modal-dialog" role="document">
                            <div class="modal-content">
                              <div class="modal-header">
                                <h4
                                  class="modal-title closebtnmodel"
                                  id="exampleModalLabel"
                                >
                                   <strong>Interview cost</strong>
                                   <button
                                  type="button"
                                  class="close icon"
                                  data-dismiss="modal"
                                  aria-label="Close"
                                >
                                  <span aria-hidden="true">&times;</span>
                                </button>
                                </h4>

                              </div>
                              <div class="modal-body">
                                <div class="saveBtnCostPage" >
                                <button  class="btn costeditbtn" @click="saveIntCostEdit()">Save</button></div>
                                <br>
                                <div class="form-row skilltest">
                    <div class="form-group " v-for="position in allDetails" :key="position">
                      <label for="" class="stest">Designation : <p style="color:black">{{position.designation}}</p></label>
                    </div>
                    <br>
                    <div class="form-group ">
                      <div>
                        <label class="stest"
                          >Skill Set : <p class="skillsets" v-for="skill in userSkills" :key="skill" style="color:black">{{skill.skill_desc}} ,</p></label
                        >
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                                  <div class="form-group">
                                    <div class="form-select">
                                      <label for="">Currency Type</label>
                        <select
                          v-model="form.currency_name"
                          class="form-control"
                          :class="{
                            'is-invalid':
                              submitted && $v.form.currency_name.$error
                          }"
                        >
                          <option value="" class="text"
                            >Interview Cost*</option
                          >
                          <option> INR </option>
                          <option>USD</option>
                        </select>
                        <span class="select-icon"
                          ><i class="fa fa-chevron-down"></i
                        ></span>
                      </div>
                      <div v-if="submitted && $v.form.currency_name.$error">
                        <p
                          v-if="!$v.form.currency_name.required"
                          class="login-alert-msg error-content"
                        >
                          * Select your value
                        </p>
                      </div>
                      </div>
                      <div class="form-group interview_cost">
                        <label for="">Cost per Interview</label>
                      <b-form-input
                        type="text"
                        placeholder="Add Interview Cost*"
                        v-model="form.interview_cost"
                         oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
                        :class="{
                          'is-invalid':
                            submitted && $v.form.interview_cost.$error
                        }"
                      />
                      <div v-if="submitted && $v.form.interview_cost.$error">
                        <p
                          v-if="!$v.form.interview_cost.required"
                          class="login-alert-msg error-content"
                        >
                          * Add the Interview Cost
                        </p>
                      </div>
                      </div>
                                </div>
                                <hr>
                                <div class="guidelines">
<h4
                                  class="modal-title guideline"
                                  id="exampleModalLabel"
                                  style="text-align:center"
                                >
                                <strong>  Guideline to determine the Interview cost</strong>
                                </h4>
                                <br>
                                <p style="font-size:14px">
                                  o  Arrive the cost based on the skills that you interview, below are the Band rate as per the standards
                          <ul class="rateforInterview"><li>0 - 5 Years - 300 INR</li>
                          <li>6 -  8 Years -500 INR</li>
                          <li>8 - 12 Years - 750 INR</li>
                          <li>Above 12 Years - 1000 INR</li></ul>
                                  o  Cost / Interview is highly acceptable by the organization when you have a good track record of taking interviews on time and reviews.
                                  <br />
                                  o   In case if you are not getting an interview request from the Organisation, your cost might be the cause. So kindly rethink.
                                  <br />
                                  o  The recommended cost per interview is the cost per hour of your skill.
                                </p>
                                <br><br>
                                <p style="text-align:center"><strong>- Note : Payment will be processed within 10-12 working days - </strong></p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- Modal  for Add Account-->
                        <div
                          class="modal fade"
                          id="addBankbtn"
                          tabindex="-1"
                          role="dialog"
                          aria-labelledby="exampleModalLabel"
                          aria-hidden="true"
                        >
                          <div class="modal-dialog" role="document">
                            <div class="modal-content">
                              <div class="modal-header">
                                <h4
                                  class="modal-title guideline"
                                  id="exampleModalLabel"
                                  style="padding:10px"
                                >
                                  <strong>Bank Details</strong>
                                  <button
                                  type="button"
                                  class="close icon"
                                  data-dismiss="modal"
                                  aria-label="Close"
                                >
                                  <span aria-hidden="true">&times;</span>
                                </button>
                                </h4>
                              </div>
                              <div class="modal-body">
<form>
  <div class="form-row bankform">
    <div class="form-group">
      <b-form-input
                        type="text"
                        placeholder="Account Number*"
                        v-model="form.account_number"
                         oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
                        :class="{
                          'is-invalid':
                            submittedfour && $v.form.account_number.$error
                        }"
                      />
                      <div v-if="submittedfour && $v.form.account_number.$error">
                        <p
                          v-if="!$v.form.account_number.required"
                          class="login-alert-msg error-content"
                        >
                          * Account Number is required
                        </p>
                      </div>
    </div>
    <div class="form-group">
            <input type="text" class="form-control" placeholder="IFSC Code" maxlength="11" v-model="form.ifsc_code" :class="{
                          'is-invalid':
                            submittedfour && $v.form.ifsc_code.$error
                        }">
                        <div v-if="submittedfour && $v.form.ifsc_code.$error">
                        <p
                          v-if="!$v.form.ifsc_code.required"
                          class="login-alert-msg error-content"
                        >
                          * IFSC Code is required
                        </p>
                      </div>
    </div>
    <div class="form-group">
      <input type="text" class="form-control" placeholder="Bank Name" v-model="form.bank_name" :class="{
                          'is-invalid':
                            submittedfour && $v.form.bank_name.$error
                        }">
                        <div v-if="submittedfour && $v.form.bank_name.$error">
                        <p
                          v-if="!$v.form.bank_name.required"
                          class="login-alert-msg error-content"
                        >
                          * Bank Name is required
                        </p>
                      </div>
    </div>
    <div class="form-group">
      <input type="text" class="form-control" placeholder="Branch" v-model="form.branch" :class="{
                          'is-invalid':
                            submittedfour && $v.form.branch.$error
                        }">
                        <div v-if="submittedfour && $v.form.branch.$error">
                        <p
                          v-if="!$v.form.branch.required"
                          class="login-alert-msg error-content"
                        >
                          * Branch Name is required
                        </p>
                      </div>
    </div>
    <div class="form-group">
      <input type="text" class="form-control" placeholder="Account Holder Name" v-model="form.holder_name" :class="{
                          'is-invalid':
                            submittedfour && $v.form.holder_name.$error
                        }">
                         <div v-if="submittedfour && $v.form.holder_name.$error">
                        <p
                          v-if="!$v.form.holder_name.required"
                          class="login-alert-msg error-content"
                        >
                          * Account Holder Name is required
                        </p>
                      </div>
                      </div>
    <div class="form-group">
      <input type="text" class="form-control" placeholder="PAN Number" maxlength="10" v-model="form.pan_number" :class="{
                          'is-invalid':
                            submittedfour && $v.form.pan_number.$error
                        }">
                         <div v-if="submittedfour && $v.form.pan_number.$error">
                        <p
                          v-if="!$v.form.pan_number.required"
                          class="login-alert-msg error-content"
                        >
                          * PAN number is required
                        </p>
                      </div>
    </div>
    <div class="form-group">
<vue-tel-input
                        class="form-control"
                        placeholder="Mobile Number"
                        @onInput="oninput"
                        v-model="form.mobileNumber"
                        v-bind:class="{ 'is-invalid': !isValidmobileNumber }"
                      ></vue-tel-input>
                      <!-- <div v-if="$v.form.mobileNumber.$error">
                        <p
                          v-if="!$v.form.mobileNumber.required"
                          class="login-alert-msg error-content"
                        >
                          * Enter your mobile number
                        </p>
                        <p
                          v-if="$v.form.mobileNumber.required && !$v.form.mobileNumber.minLength"
                          class="login-alert-msg error-content"
                        >
                          * Enter a valid mobile number
                        </p>
                      </div> -->
                      </div>
  </div>
  <br>
      <label style="text-align:center" for="">DOCUMENTS FOR VERIFICATION</label>
<br>
  <div class="form-row skills">
                      <div class="UserUpload">
                        <div class="form-group">
                          <label>Attach your PAN card*</label>
                          <div class="custom-file-upload">
                            <div v-if="pan.length < 1" class="show-doc-empty">
                              Select the File
                            </div>
                            <div class="show-doc" v-if="pan.length > 0">
                              <span
                                class="doc-file pull-left"
                                v-for="x in pan.slice(0, 2)"
                                :key="x"
                                ><span class="doc-name">{{ x.name }} </span
                                ><i
                                  @click="removePancard(x)"
                                  class="fa fa-times"
                                  style="color: #ccc;"
                                  aria-hidden="true"
                                ></i
                              ></span>
                            </div>
                            <label for="pan"
                              ><i class="uil uil-upload" aria-hidden="true"></i> Upload
                            </label>
                            <input
                              @change="panUpload($event)"
                              style="visibility: hidden;"
                              type="file"
                              id="pan"
                              name="myfiles[]"
                              multiple
                            />
                          </div>
                          <p style="color: #aeaaaa;margin: 3px 0 10px;">
                           Size (Max 2MB)
                          </p>
                          <span v-if="panErrorShow" class="error-msg">* Please select the file</span>
                        </div>
                      </div>
                    </div>
                    <div class="form-row skills">
                      <div class="UserUpload">
                        <div class="form-group">
                          <label>Attach your Aadhar card*</label>
                          <div class="custom-file-upload">
                            <div v-if="aadhar.length < 1" class="show-doc-empty">
                              Select the File
                            </div>
                            <div class="show-doc" v-if="aadhar.length > 0">
                              <span
                                class="doc-file pull-left"
                                v-for="x in aadhar.slice(0, 2)"
                                :key="x"
                                ><span class="doc-name">{{ x.name }} </span
                                ><i
                                  @click="removeAadharcard(x)"
                                  class="fa fa-times"
                                  style="color: #ccc;"
                                  aria-hidden="true"
                                ></i
                              ></span>
                            </div>
                            <label for="aadhar"
                              ><i class="uil uil-upload" aria-hidden="true"></i> Upload
                            </label>
                            <input
                              @change="aadharUpload($event)"
                              style="visibility: hidden;"
                              type="file"
                              id="aadhar"
                              name="myfiles[]"
                              multiple
                            />
                          </div>
                          <p style="color: #aeaaaa;margin: 3px 0 10px;">
                          Size (Max 2MB)
                          </p>
                          <span v-if="aadharErrorShow" class="error-msg">* Please select the file</span>
                        </div>
                      </div>
                    </div>
                    <div class="form-col">
                      <div class="form-group myUploadBtn">
                        <button type="button" class="btn btn-success btn-md addbtn1" @click="submitAttachment()"
                        >
                          SUBMIT
                        </button>
                      </div>
                    </div>
</form>
                              </div>
                              <div class="modal-footer">
                                <button
                                  type="button"
                                  class="btn btn-secondary"
                                  data-dismiss="modal"
                                >
                                  Close
                                </button>
                                <button
                                  type="button"
                                  class="btn saveaccdetialsbtn "
                                  @click="addBankDetails()"
                                >
                                  Save
                                </button>
                                </div>
                            </div>
                          </div>
                        </div>
                        <!-- modal for edit bank details -->
<div class="modal fade" id="editBankbtn" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content editbankdetails">
      <div class="modal-header">
        <h4 class="modal-title guideline" id="exampleModalLabel"
                                          style="padding:10px"
><strong class="intexp">Update Bank Account</strong> <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button></h4>
      </div>
      <div class="modal-body">
<form>
  <div class="form-row bankform">
    <div class="form-group">
      <b-form-input
                        type="text"
                        placeholder="Account Number*"
                        v-model="form.account_number"
                         oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
                        :class="{
                          'is-invalid':
                            submittedfour && $v.form.account_number.$error
                        }"
                      />
                      <div v-if="submittedfour && $v.form.account_number.$error">
                        <p
                          v-if="!$v.form.account_number.required"
                          class="login-alert-msg error-content"
                        >
                          * Account Number is required
                        </p>
                      </div>
    </div>
    <div class="form-group">
            <input type="text" class="form-control" placeholder="IFSC Code" v-model="form.ifsc_code" :class="{
                          'is-invalid':
                            submittedfour && $v.form.ifsc_code.$error
                        }">
                        <div v-if="submittedfour && $v.form.ifsc_code.$error">
                        <p
                          v-if="!$v.form.ifsc_code.required"
                          class="login-alert-msg error-content"
                        >
                          * IFSC Code is required
                        </p>
                      </div>
    </div>
    <div class="form-group">
      <input type="text" class="form-control" placeholder="Bank Name" v-model="form.bank_name" :class="{
                          'is-invalid':
                            submittedfour && $v.form.bank_name.$error
                        }">
                        <div v-if="submittedfour && $v.form.bank_name.$error">
                        <p
                          v-if="!$v.form.bank_name.required"
                          class="login-alert-msg error-content"
                        >
                          * Bank Name is required
                        </p>
                      </div>
    </div>
    <div class="form-group">
      <input type="text" class="form-control" placeholder="Branch" v-model="form.branch" :class="{
                          'is-invalid':
                            submittedfour && $v.form.branch.$error
                        }">
                        <div v-if="submittedfour && $v.form.branch.$error">
                        <p
                          v-if="!$v.form.branch.required"
                          class="login-alert-msg error-content"
                        >
                          * Branch Name is required
                        </p>
                      </div>
    </div>
    <div class="form-group">
      <input type="text" class="form-control" placeholder="Account Holder Name" v-model="form.holder_name" :class="{
                          'is-invalid':
                            submittedfour && $v.form.holder_name.$error
                        }">
                         <div v-if="submittedfour && $v.form.holder_name.$error">
                        <p
                          v-if="!$v.form.holder_name.required"
                          class="login-alert-msg error-content"
                        >
                          * Account Holder Name is required
                        </p>
                      </div>
                      </div>
    <div class="form-group">
      <input type="text" class="form-control" placeholder="PAN Number" v-model="form.pan_number" :class="{
                          'is-invalid':
                            submittedfour && $v.form.pan_number.$error
                        }">
                         <div v-if="submittedfour && $v.form.pan_number.$error">
                        <p
                          v-if="!$v.form.pan_number.required"
                          class="login-alert-msg error-content"
                        >
                          * PAN number is required
                        </p>
                      </div>
    </div>
    <div class="form-group">
<vue-tel-input
                        class="form-control"
                        placeholder="Mobile Number"
                        @onInput="oninput"
                        v-model="form.mobileNumber"
                        v-bind:class="{ 'is-invalid': !isValidmobileNumber }"
                      ></vue-tel-input>
                      <!-- <div v-if="$v.form.mobileNumber.$error">
                        <p
                          v-if="!$v.form.mobileNumber.required"
                          class="login-alert-msg error-content"
                        >
                          * Enter your mobile number
                        </p>
                        <p
                          v-if="$v.form.mobileNumber.required && !$v.form.mobileNumber.minLength"
                          class="login-alert-msg error-content"
                        >
                          * Enter a valid mobile number
                        </p>
                      </div> -->
                      </div>
  </div>
  <br>
      <label style="text-align:center" for="">DOCUMENTS FOR VERIFICATION</label>
<br>
<div class="form-row skills">
                      <div class="UserUpload">
                        <div class="form-group">
                          <label>Attach your PAN card*</label>
                          <div class="custom-file-upload">
                            <div v-if="pan.length < 1" class="show-doc-empty">
                              Select the File
                            </div>
                            <div class="show-doc" v-if="pan.length > 0">
                              <span
                                class="doc-file pull-left"
                                v-for="x in pan.slice(0, 2)"
                                :key="x"
                                ><span class="doc-name">{{ x.name }} </span
                                ><i
                                  @click="removePancard(x)"
                                  class="fa fa-times"
                                  style="color: #ccc;"
                                  aria-hidden="true"
                                ></i
                              ></span>
                            </div>
                            <label for="pan"
                              ><i class="uil uil-upload" aria-hidden="true"></i> Upload
                            </label>
                            <input
                              @change="panUpload($event)"
                              style="visibility: hidden;"
                              type="file"
                              id="pan"
                              name="myfiles[]"
                              multiple
                            />
                          </div>
                          <p style="color: #aeaaaa;margin: 3px 0 10px;">
                           Size (Max 2MB)
                          </p>
                          <span v-if="panErrorShow" class="error-msg">* Please select the file</span>
                        </div>
                      </div>
                    </div>
<br>

<div class="viewPanImage">
  <div>{{form.pancard_image
}}</div><button type="button" class="btn saveaccdetialsbtn" @click="viewPanImage()">{{changePanBtnText}}</button>
</div>
<a href="#" v-show="showPanImage">
<img alt="Qries" :src="`${form.pancard_image}`"  width="150" height="70">
</a>
<br>
<hr>
<div class="form-row skills">
                      <div class="UserUpload">
                        <div class="form-group">
                          <label>Attach your Aadhar card*</label>
                          <div class="custom-file-upload">
                            <div v-if="aadhar.length < 1" class="show-doc-empty">
                              Select the File
                            </div>
                            <div class="show-doc" v-if="aadhar.length > 0">
                              <span
                                class="doc-file pull-left"
                                v-for="x in aadhar.slice(0, 2)"
                                :key="x"
                                ><span class="doc-name">{{ x.name }} </span
                                ><i
                                  @click="removeAadharcard(x)"
                                  class="fa fa-times"
                                  style="color: #ccc;"
                                  aria-hidden="true"
                                ></i
                              ></span>
                            </div>
                            <label for="aadhar"
                              ><i class="uil uil-upload" aria-hidden="true"></i> Upload
                            </label>
                            <input
                              @change="aadharUpload($event)"
                              style="visibility: hidden;"
                              type="file"
                              id="aadhar"
                              name="myfiles[]"
                              multiple
                            />
                          </div>
                          <p style="color: #aeaaaa;margin: 3px 0 10px;">
                          Size (Max 2MB)
                          </p>
                          <span v-if="aadharErrorShow" class="error-msg">* Please select the file</span>
                        </div>
                      </div>
                    </div>
                    <br>
<div class="viewAadharImage">
  <div>{{form.aadharcard_image}}
</div> <button type="button" class="btn saveaccdetialsbtn" @click="viewAadharImage()">{{changeAadharBtnText}}</button>
</div>
<a href="#" v-show="showAadharImage">
<img alt="Qries" :src="`${form.aadharcard_image}`"  width="150" height="70">
</a>
</form>
<div class="form-col">
                      <div class="form-group myUploadBtn">
                        <button type="button" class="btn btn-success btn-md addbtn" @click="submitAttachment()"
                        >
                          SUBMIT
                        </button>
                      </div>
                    </div>
                              </div>
      <div class="modal-footer"><button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button><button type="button" class="btn saveaccdetialsbtn" @click="updateBankDetails()">Update</button>

      </div>
    </div>
  </div>
</div>
                        <!-- modal for delete skills -->
                        <div
        class="modal fade " id="deleteModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog deleteskillmodal" role="document">
          <div class="modal-content " style="width:55%;">
            <div class="modal-header">
              <h3 class="modal-title skilltitle" id="exampleModalLabel" style="text-align:center">Delete Skill  <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button></h3>

            </div>
            <div class="modal-body">
              <p>Are you sure to delete the Required skills?</p>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                No
              </button>
              <button type="button" class="btn removeSkill" @click="removeSkill(tempId, tempIndex)">
                Yes
              </button>
            </div>
          </div>
        </div>
      </div>
</div>
</div>
</section>
  </div>
</template>
<script>
import ICountry from 'country-state-city'
import StarRating from 'vue-star-rating'
import { validationMixin } from 'vuelidate'
import { required, maxLength, minLength, sameAs } from 'vuelidate/lib/validators'
import { VueTelInput } from 'vue-tel-input'
import axios from 'axios'
import { BaseURL } from '../../../shared/classes'
import $ from 'jquery'
import myUpload from 'vue-image-crop-upload'
// import Accordion from '../accordion'
// import AccordionItem from '../accordion-item'

export default {
  name: 'userprofile',
  components: {
    StarRating,
    VueTelInput,
    'my-upload': myUpload
    // Accordion,
    // AccordionItem
  },
  data () {
    return {
      form1: { user_bio: '' },
      form2: {
        // interviewer experience
        designation: '',
        Experience: '',
        month_of_experience: '',
        organizationStatus: '',
        current_user_organization: ''
      },
      form: {
        // personal detials
        first_name: '',
        last_name: '',
        gender: '',
        country_name: '',
        state_name: '',
        user_email: localStorage.getItem('user_email'),
        // skills & rating
        skill_desc: '',
        self_rating: '1',
        yearofexperience: '',
        monthofexperience: '',
        // bank details
        account_number: '',
        ifsc_code: '',
        bank_name: '',
        branch: '',
        holder_name: '',
        pan_number: '',
        _id: '',
        mobileNumber: '',
        mobile_number_country_code: '',
        aadharcard_image: '',
        pancard_image: '',
        // password page
        oldpassword: '',
        newpassword: '',
        confirmPassword: ''

      },
      passwordFieldType: 'password',
      passwordFieldType1: 'password',
      passwordFieldType2: 'password',
      password_length: 0,
      contains_eight_characters: false,
      contains_number: false,
      contains_uppercase: false,
      contains_special_character: false,
      errormsg: false,
      updateExp: '',
      submitted: false,
      submittedone: false,
      // submittedtwo: false,
      // skills declaration
      // user_id: '',
      signup: '',
      skills: [],
      skillData: [],
      matchName: '',
      userSkills: [],
      listSkills: [],
      skill_id: [],
      user_skill_id: '',
      addedSkills: '',
      submittedtwo: false,
      submittedthree: false,
      submittedfour: false,
      skillexpired: false,
      tempId: '',
      isValiedmobileNumber: true,
      isValidmobileNumber: true,
      State: '',
      Country: ICountry.getAllCountries(),
      showtextbox: true,
      userProfile: '',
      successMsg: '',
      messageStatus: '',
      user_id: localStorage.getItem('user_id'),
      allDetails: [],
      intDetails: [],
      mymessage: '',
      percentage: [],
      bankStatus: '',
      bankAccount: [],
      edit_user_id: '',
      edit_id: '',
      pan: [],
      aadhar: [],
      panErrorShow: false,
      aadharErrorShow: false,
      shortIntroData: '',
      mycurrency: '',
      mycostperinterview: '',
      profileEditPop: false,
      accountdetails: false,
      isHidden: false,
      stats: false,
      costMsg: '',
      getBankData: [],
      getWalletData: [],
      iacWalletData: [],
      IntStats: [],
      imgDataUrl: '',
      formdatas: [],
      show: false,
      noRotate: false,
      noSquare: true,
      params: {
        name: 'image',
        uid: ''
      },
      messagDeleteStatus: '',
      updatemessageStatus: '',
      allDetailsPic: [],
      myDatas: [],
      files: [],
      files1: [],
      files2: [],
      video: [],
      showpreview: false,
      videoErrorShow: false,
      fileErrorShow: false,
      introvideo: false,
      isTrue: false,
      panResponse: '',
      aadharResponse: '',
      resumeResponse: '',
      showPanImage: false,
      showAadharImage: false,
      changePanBtnText: 'View',
      changeAadharBtnText: 'View',
      changePasswordResponse: '',
      getMyResume: [],
      getMyintroVideo: [],
      todayEarnedHistory: [],
      otherEarnedHistory: [],
      walletHistory: [],
      todayWithdrawHistory: [],
      otherWithdrawHistory: [],
      selectedAccount: [],
      selectedAccountNumber: '',
      withdraw_amount: '',
      headers: {
        smail: '*_~'
      },
      // <!-- Options struct: -->
      options: {
        text: {
          color: 'white',
          shadowEnable: true,
          shadowColor: '#000000',
          fontSize: 10,
          fontFamily: 'Helvetica',
          dynamicPosition: false,
          hideText: false
        },
        progress: {
          color: '#5bad2b',
          backgroundColor: 'lightgray',
          inverted: false
        },
        layout: {
          height: 18,
          width: 212,
          verticalTextAlign: 61,
          horizontalTextAlign: 43,
          zeroOffset: 0,
          strokeWidth: 30,
          progressPadding: 0,
          type: 'line'
        }
      }
    }
  },
  computed: {
    filteredSkills () {
      return this.skills.filter(get =>
        get.name.toLowerCase().includes(this.form.skill_desc.toLowerCase())
      )
    }
  },
  created () {
    console.log(localStorage.getItem('token'))
    this.intDetails = JSON.parse(localStorage.getItem('user__details'))
    localStorage.setItem('setPassword', JSON.stringify(false))
    this.form.first_name = this.intDetails.first_name
    this.form.last_name = this.intDetails.last_name
    this.form.user_email = this.intDetails.user_email
    this.form.currency_name = this.intDetails.currency_name
    if (this.intDetails.country_name) {
      this.form.country_name = this.intDetails.country_name
      this.form.country_id = this.intDetails.country_id
      this.form.country_sort_name = this.intDetails.country_sort_name
      this.form.state_id = this.intDetails.state_id
      this.form.state_name = this.intDetails.state_name
    }
    console.log(this.intDetails)
    if (this.intDetails.country_name) {
      this.Country = ICountry.getAllCountries()
      this.getState()
    }
    this.form.interview_cost = this.intDetails.interview_cost
    this.getaddedSkills()
    this.allSkillList()
    this.getUserDetails()
    this.getBankDetails()
    this.interviewerStats()
    this.getEarnedHistory()
    this.getWithdrawHistory()
    // this.updateBankDetails()
    console.log(this.intDetails)
    // this.submitted = true
    // return this.$v.$touch()
  },
  mixins: [validationMixin],
  validations: {
    form1: {
      user_bio: {
        required
        // maxLength: minLength(50)
      }
    },
    form2: {
      designation: {
        required
      },
      Experience: {
        required
      },
      month_of_experience: {
        required
      },
      organizationStatus: {
        required,
        maxLength: maxLength(20)
      },
      current_user_organization: {
        required
      }
    },
    form: {
      currency_name: {
        required
      },
      interview_cost: {
        required
      },
      // skills & rating
      skill_desc: {
        required
      },
      yearofexperience: {
        required
      },
      monthofexperience: {
        required
      },
      // personal details
      first_name: {
        required
      },
      last_name: {
        required
      },
      mobile_number: {
        required,
        maxLength: maxLength(10)
      },
      gender: { required },
      country_name: { required },
      state_name: { required },
      country_id: {},
      country_sort_name: {},
      state_id: {},
      // bank details validation
      account_number: {
        required,
        maxLength: maxLength(15)
      },
      ifsc_code: {
        required
        // maxLength: maxLength(15)
      },
      bank_name: {
        required
        // maxLength: maxLength(15)
      },
      branch: {
        required
        // maxLength: maxLength(15)
      },
      holder_name: {
        required
        // maxLength: maxLength(15)
      },
      pan_number: { required },
      oldpassword: {
        required,
        minLength: minLength(8),
        strongPassword (userpassword) {
          return (
            /[a-z]/.test(userpassword) && // checks for a-z
            /[0-9]/.test(userpassword) && // checks for 0-9
            /\W|_/.test(userpassword) && // checks for special char
            userpassword.length >= 8
          )
        }
      },
      newpassword: {
        required,
        minLength: minLength(8),
        strongPassword (userpassword) {
          return (
            /[a-z]/.test(userpassword) && // checks for a-z
            /[0-9]/.test(userpassword) && // checks for 0-9
            /\W|_/.test(userpassword) && // checks for special char
            userpassword.length >= 8
          )
        }
      },
      confirmPassword: { required, sameAsPassword: sameAs('password') }
    }
  },
  methods: {
    myFunction () {
      var x = document.getElementById('myTopnav')
      if (x.className === 'tabHeader') {
        x.className += ' responsive'
      } else {
        x.className = 'tabHeader'
      }
    },
    getState () {
      const data = this.Country.find(country => country.name === this.form.country_name)
      this.form.country_id = data.id
      this.form.country_sort_name = data.sortname
      this.State = ICountry.getStatesOfCountry(data.id)
      this.form.state_name = this.intDetails.state_name
    },
    getCity () {
      const data = this.State.find(country => country.name === this.form.state_name)
      this.form.state_name = data.name
      this.form.state_id = data.id
      this.City = ICountry.getCitiesOfState(data.id)
    },
    chkState (val) {
      const field = this.$v.form[val]
      return !field.$dirty || !field.$invalid
    },
    findFirstError (component = this) {
      if (component.state_name === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })
      return focused
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    onInput ({ number, isValid, country }) {
      console.log(this.form)
      console.log(isValid)
      console.log(country)
      this.isValiedmobileNumber = true
      this.form.mobile_number_country_code = country.dialCode
      this.form.mobile_number = number.significant
      this.$v.form.mobile_number.required = true
    },
    oninput ({ number, isValid, country }) {
      console.log(this.form)
      console.log(isValid)
      console.log(country)
      this.isValidmobileNumber = true
      this.form.mobile_number_country_code = country.dialCode
      this.form.mobileNumber = number.significant
    },

    // get user details
    getUserDetails () {
      axios.get(BaseURL + '/profile/get_user_detail/' + this.user_id).then(response => {
        this.allDetails = response.data.profileDetail
        this.myDatas = response.data.profileDetail[0]
        this.allDetailsPic = this.myDatas
        const allDetails = response.data.profileDetail[0]
        this.percentage = response.data.user_percentage
        console.log(allDetails.currency_name)
        // this.form.organizationStatus = this.allDetails.organizationStatus
        this.form2.designation = allDetails.designation
        this.form2.Experience = allDetails.experience
        this.form2.month_of_experience = allDetails.month_of_experience
        this.form2.organizationStatus = allDetails.organization_status
        this.form2.current_user_organization = allDetails.current_user_organization
        this.shortIntroData = allDetails.user_bio
        this.mycurrency = allDetails.currency_name
        this.mycostperinterview = allDetails.interview_cost

        this.form.first_name = allDetails.first_name
        this.form.last_name = allDetails.last_name
        this.form.gender = allDetails.gender
        this.form.country_name = allDetails.country_name
        this.form.state_name = allDetails.state_name
        this.form.user_email = allDetails.user_email
        this.form.mobile_number = allDetails.mobile_number

        this.form.currency_name = allDetails.currency_name
        this.form.interview_cost = allDetails.interview_cost

        console.log(allDetails)
        console.log(this.percentage)
        // this.saveIntCostEdit()
      })
    },
    // work experience
    workExperience () {
      this.submitted = true
      // this.user_id = localStorage.getItem('_id')
      // if (this.submitted && this.$v.form.$invalid) {
      this.$v.$touch()
      // } else {
      const data = {
        designation: this.form2.designation,
        Experience: this.form2.Experience,
        month_of_experience: this.form2.month_of_experience,
        organizationStatus: this.form2.organizationStatus,
        current_user_organization: this.form2.current_user_organization
      }
      console.log(data)
      const config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }
      axios.post(BaseURL + '/profile/update_user_profile_ios/' + this.user_id, { formData: data }, config).then(response => {
        this.userProfile = response.data.user_id
        this.successMsg = response.data.message
        // localStorage.setItem('token', JSON.stringify(this.updateExp))
        if (this.successMsg === 'Success') {
          this.$awn.success('Work Experience is updated Successfully')
          this.getUserDetails()

          // this.$router.push('/InterviewerProfile')
        } else {
          // alert('User Details Required')
        }
      })
      // }
    },
    // password Visibility
    switchVisibility1 () {
      this.passwordFieldType1 =
        this.passwordFieldType1 === 'password' ? 'text' : 'password'
    },
    switchVisibility2 () {
      this.passwordFieldType2 =
        this.passwordFieldType2 === 'password' ? 'text' : 'password'
    },
    // shortintro method
    shortIntro () {
      if (this.form1.user_bio === undefined || this.form1.user_bio === '') {
        this.submittedone = true
        this.$v.$touch()
        $('#shortIntro').modal('show')
      } else {
        this.submittedone = true
        this.$v.$touch()
        const data = {
          user_bio: this.form1.user_bio
        }
        const config = {
          headers: {
            'content-type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token')
          }
        }
        axios.post(BaseURL + '/profile/update_user_bio/' + this.user_id, { formData: data }, config).then(response => {
          this.mymessage = response.data.message
          if (this.mymessage === 'Success') {
            $('#shortIntro').modal('hide')
            this.getUserDetails()
            this.$awn.success('Short Intro is updated Successfully')
          }
        })
      }
      // e.preventDefault()
    },
    shortIntroEdit () {
      this.form1.user_bio = this.shortIntroData
    },
    onProfileEdit () {
      this.profileEditPop = true
      this.form.first_name = this.myDatas.first_name
      this.form.last_name = this.myDatas.last_name
      this.form.gender = this.myDatas.gender
      this.form.country_name = this.myDatas.country_name
      this.form.state_name = this.myDatas.state_name
      this.form.user_email = this.myDatas.user_email
      this.form.mobile_number = this.myDatas.mobile_number
    },
    // profile page
    onUpdateProfile () {
      // this.user_id = localStorage.getItem('_id')
      // if (this.submitted && this.$v.form.$invalid) {
      this.$v.$touch()
      // } else {
      const data = {
        first_name: this.form.first_name,
        last_name: this.form.last_name,
        gender: this.form.gender,
        user_email: this.form.user_email,
        country_name: this.form.country_name,
        country_id: this.form.country_id,
        country_sort_name: this.form.country_sort_name,
        state_id: this.form.state_id,
        state_name: this.form.state_name,
        mobile_number_country_code: this.form.mobile_number_country_code,
        mobile_number: this.form.mobile_number
      }
      if ((this.form.mobile_number === '' || this.form.mobile_number === null || !this.form.country_name) || !this.form.state_name) {
        return false
      } else {
        this.submittedthree = true
        $('#profileEdit').modal('hide')
      }
      console.log(data)
      const config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }
      axios.post(BaseURL + '/profile/update_user_basicinfo/' + this.user_id, { formData: data }, config).then(response => {
        // this.userProfile = response.data.user_id
        this.messageStatus = response.data.message
        // localStorage.setItem('token', JSON.stringify(this.updateExp))
        console.log(this.signup)
        if (this.messageStatus === 'Success') {
          this.$awn.success('profile  updated Successfully')
          this.profileEditPop = false
          localStorage.setItem('user__details', JSON.stringify(response.data.userdetail))
          // $('#deleteModal').modal('hide')
          // this.getUserDetails()

          // this.$router.push('/InterviewerProfile')

          // $('#button').submit(function (e) {
          //   e.preventDefault()
          //   // Coding
          //   $('#profileEdit').modal('hide') // or  $('#IDModal').modal('hide');
          //   return false
          // })
        } else {
          // alert('User Details Required')
        }
      })
    },
    // skills form
    allSkillList () {
      const config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }
      axios
        .get(BaseURL + '/skills/skills/ios', config)
        .then(response => {
          this.skills = response.data.all_skill
        })
        .catch(e => {})
    },
    getSkill () {
      this.form.skill_desc = this.skillData[0].name
      console.log(this.form.skill_desc)
    },
    searchSkill () {
      this.skillData = this.skills
      if (this.form.skill_desc !== '' || this.form.skill_desc !== null) {
        for (let j = 0; j < this.skillData.length; j++) {
          this.matchName = this.skillData[j].name

          if (
            this.matchName
              .toLowerCase()
              .match(this.form.skill_desc.toLowerCase())
          ) {
            this.skills.push(this.skillData[j].name)
          }
        }
      }
    },
    getTime (event) {
      this.form.Experience = this.yearList.find(
        item => item.id === Number(event.target.value)
      )
    },
    getaddedSkills () {
      const config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }
      axios.get(BaseURL + '/profile/user/skill/' + this.user_id
        , config).then(response => {
        this.addedSkills = response.data.userSkillInfo
        this.userSkills = response.data.userSkillInfo
      }).catch(e => {})
    },
    interviewerSkills () {
      this.submittedtwo = true
      this.$v.$touch()
      this.skillexpired = false
      // this.user_id = localStorage.getItem('_id')
      if (
        (this.form.skill_desc &&
          this.form.self_rating &&
          this.form.yearofexperience &&
          this.form.monthofexperience) === ''
      ) {
        this.$v.$touch()
      } else {
        const data = {
          skill_desc: this.form.skill_desc,
          self_rating: this.form.self_rating,
          yearofexperience: this.form.yearofexperience,
          monthofexperience: this.form.monthofexperience
        }
        console.log(data)
        const config = {
          headers: {
            'content-type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token')
          }
        }
        axios.post(BaseURL + '/profile/add/user/skill/' + this.user_id, { formData: data }, config).then(response => {
          this.signup = response.data.message
          this.userSkills = response.data.userSkillInfo
          console.log(this.userSkills)
          console.log(this.signup)
          if (this.signup === 'Skill Already Exist') {
            this.skillexpired = true
            this.getaddedSkills()
          } else {
            this.listSkills.push(data)
            this.getaddedSkills()
          }
        })
      }
    },
    tempSkill (skill, index) {
      this.tempId = skill._id
      this.tempIndex = index
    },
    removeSkill (skill, index) {
      this.userSkills.splice(index, 1)
      $('#deleteModal').modal('hide')
      const config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }
      axios
        .get(
          BaseURL + '/profile/user/skill/delete/' + this.user_id + '/' + skill,
          config
        )
        .then(response => {
          console.log(this.skillId)
        })
      this.$awn.success('Skill Deleted successfully')
    },
    accDetails () {
      this.accountdetails = false
      this.isHidden = false
      this.stats = false
    },
    walletDetails () {
      this.accountdetails = true
      this.isHidden = true
      this.stats = false
    },
    statDetails () {
      this.accountdetails = true
      this.isHidden = false
      this.stats = true
    },
    editmyBankdata (_id) {
      this.bankAccount = this.getBankData[_id]
      this.edit_id = this.bankAccount._id
      this.edit_user_id = this.bankAccount.user_id
      this.form.account_number = this.bankAccount.account_number
      this.form.ifsc_code = this.bankAccount.ifsc_code
      this.form.bank_name = this.bankAccount.bank_name
      this.form.branch = this.bankAccount.branch
      this.form.holder_name = this.bankAccount.holder_name
      this.form.pan_number = this.bankAccount.pan_number
      this.form.mobile_number_country_code = this.bankAccount.mobile_number_code
      this.form.mobileNumber = this.bankAccount.mobile_number
      // mobile_number_country_code: this.form.mobile_number_country_code,
      this.form.pancard_image = this.bankAccount.pancard_image
      this.form.aadharcard_image = this.bankAccount.aadharcard_image
      // axios.post().then(response => {})
    },
    saveIntCostEdit () {
      this.submitted = true
      $('#editcostbtn').modal('hide')

      // this.user_id = localStorage.getItem('_id')
      // if (this.submitted && this.$v.form.$invalid) {
      this.$v.$touch()
      // } else {
      const data = {
        designation: this.myDatas.designation,
        Experience: this.myDatas.experience,
        month_of_experience: this.myDatas.month_of_experience,
        organizationStatus: this.myDatas.organization_status,
        current_user_organization: this.myDatas.current_user_organization,
        currency_name: this.form.currency_name,
        interview_cost: this.form.interview_cost
      }
      console.log(data)
      const config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }
      axios.post(BaseURL + '/profile/update_user_profile_ios/' + this.user_id, { formData: data }, config).then(response => {
        // this.userProfile = response.data.user_id
        this.costMsg = response.data.message
        // localStorage.setItem('token', JSON.stringify(this.updateExp))
        console.log(this.signup)
        if (this.costMsg === 'Success') {
          this.$awn.success('cost is updated Successfully')
          this.getUserDetails()

          // this.$router.push('/InterviewerProfile')
        } else {
          // alert('User Details Required')
        }
      })
      // }
    },
    editCost () {
      this.form.currency_name = this.mycurrency
      this.form.interview_cost = this.mycostperinterview
      console.log(this.form.currency_name)
      console.log(this.form.interview_cost)
    },
    // bank details function
    addAccountPopUp () {
      // user_id: this.user_id,
      this.form.account_number = ''
      this.form.ifsc_code = ''
      this.form.bank_name = ''
      this.form.branch = ''
      this.form.holder_name = ''
      this.form.pan_number = ''
      this.form.mobile_number_country_code = ''
      this.form.mobileNumber = ''
      // mobile_number_country_code: this.form.mobile_number_country_code,
      this.pan = []
      this.aadhar = []
    },
    addBankDetails () {
      this.submittedfour = true
      this.$v.$touch()
      const data = {
        user_id: this.user_id,
        account_number: this.form.account_number,
        ifsc_code: this.form.ifsc_code,
        bank_name: this.form.bank_name,
        branch: this.form.branch,
        holder_name: this.form.holder_name,
        pan_number: this.form.pan_number,
        mobile_number_code: this.form.mobile_number_country_code,
        mobile_number: this.form.mobileNumber,
        // mobile_number_country_code: this.form.mobile_number_country_code,
        pancard_image: this.pancardUrl,
        aadharcard_image: this.aadharcardUrl
      }
      const config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }
      axios.post(BaseURL + '/profile/add_bank_details', { formData: data }, config).then(response => {
        this.bankStatus = response.data.message
        if (this.bankStatus === 'Success') {
          $('#addBankbtn').modal('hide')
          this.getBankDetails()
          this.$awn.success('Bank Details Updated Successfully')
        } else {
        }
      })
    },
    getBankDetails () {
      const data = {
        user_id: this.user_id
      }
      axios.post(BaseURL + '/profile/get_bank_details', { formData: data }).then(response => {
        this.getBankData = response.data.bank_details
        this.getWalletData = response.data.wallet_details[0]
        this.iacWalletData = response.data.iac_wallet_details
        console.log(this.getWalletData)
        console.log(this.iacWalletData)
        console.log(this.getBankData)
        if (this.getWalletData === null || this.getWalletData === undefined) {
          this.getWalletData = 0
        }
        this.getUserDetails()
      })
    },
    setBankData (_id) {
      this.selectedAccount = this.getBankData[_id]
      this.selectedAccountNumber = this.selectedAccount.account_number
      console.log(this.selectedAccountNumber)
      console.log(this.selectedAccount)
    },
    transferMoney () {
      const data = {
        user_id: this.user_id,
        withdraw_amount: this.withdraw_amount,
        payment_mode: this.payment_mode,
        bank_id: this.selectedAccount._id
      }
      const config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }
      axios.post(BaseURL + '/dashboard/add_withdraw', { formData: data }, config).then(response => {
        // this.getBankData = response.data.bank_details
        // this.getWalletData = response.data.wallet_details[0]
        // this.iacWalletData = response.data.iac_wallet_details
        // console.log(this.getWalletData)
        // console.log(this.iacWalletData)
        // console.log(this.getBankData)
        // if (this.getWalletData === null || this.getWalletData === undefined) {
        //   this.getWalletData = 0
        // }
      })
    },
    getEarnedHistory () {
      const data = {
        user_id: this.user_id
      }
      const config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }
      axios.post(BaseURL + '/dashboard/get_earned_history', { formData: data }, config).then(response => {
        this.todayEarnedHistory = response.data.today_history_list
        this.otherEarnedHistory = response.data.other_history_list
        this.walletHistory = response.data.wallet_details
        console.log(this.otherEarnedHistory)
      })
    },
    getWithdrawHistory () {
      const data = {
        user_id: this.user_id
      }
      const config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }
      axios.post(BaseURL + '/dashboard/get_withdraw_history', { formData: data }, config).then(response => {
        this.todayWithdrawHistory = response.data.today_history_list
        this.otherWithdrawHistory = response.data.other_history_list
        console.log(this.todayWithdrawHistory)
      })
    },
    viewPanImage () {
      if (this.changePanBtnText === 'View') {
        this.changePanBtnText = 'Hide'
        this.showPanImage = true
      } else {
        this.changePanBtnText = 'View'
        this.showPanImage = false
      }
    },
    viewAadharImage () {
      this.showAadharImage = true
      if (this.changeAadharBtnText === 'View') {
        this.changeAadharBtnText = 'Hide'
        this.showAadharImage = true
      } else {
        this.changeAadharBtnText = 'View'
        this.showAadharImage = false
      }
    },
    updateBankDetails () {
      this.submittedfour = true
      $('#editBankbtn').modal('hide')

      this.$v.$touch()
      const data = {
        _id: this.edit_id,
        user_id: this.edit_user_id,
        account_number: this.form.account_number,
        ifsc_code: this.form.ifsc_code,
        bank_name: this.form.bank_name,
        branch: this.form.branch,
        holder_name: this.form.holder_name,
        pan_number: this.form.pan_number,
        mobile_number_code: this.form.mobile_number_country_code,
        mobile_number: this.form.mobileNumber,
        // mobile_number_country_code: this.form.mobile_number_country_code,
        pancard_image: this.form.pancard_image,
        aadharcard_image: this.form.aadharcard_image
      }
      const config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }
      axios.post(BaseURL + '/profile/update_bank_details', { formData: data }, config).then(response => {
        this.updatemessageStatus = response.data.message
        if (this.updatemessageStatus === 'Success') {
          this.getBankDetails()
          this.$awn.success('Bank Details Updated Successfully')
        } else {
          // alert('User Details Required')
        }
      })
    },

    deleteBank (_id) {
      this._id = this.getBankData[_id]._id
      this.getBankData.splice(_id, 1)
      const data = {
        _id: this._id
      }
      const config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }
      axios.post(BaseURL + '/profile/delete_bank_account', { formData: data }, config).then(response => {
        this.messagDeleteStatus = response.data.message
        if (this.messagDeleteStatus === 'Success') {
          this.$awn.success('Bank Details Deleted Successfully')
        } else {
        }
      })
    },
    interviewerStats () {
      const data = {
        user_id: this.user_id
      }
      const config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }
      axios.post(BaseURL + '/dashboard/get_interviewer_count_details', { formData: data }, config).then(response => {
        // this.Stats = response.data.message
        this.IntStats = response.data.count_details[0]
        console.log(this.IntStats)
      })
    },
    // image upload
    toggleShow () {
      this.show = !this.show
    },
    cropSuccess (imgDataUrl, field) {
      console.log('-------- crop success --------')
      this.imgDataUrl = imgDataUrl
      console.log(this.imgDataUrl)
      this.formdatas = []
      const formData = new FormData()
      formData.append('image', this.imgDataUrl)
      formData.append('uid', this.user_id)
      this.formdatas = {
        image: this.imgDataUrl,
        uid: this.user_id
      }
      const config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }
      axios.post(BaseURL + '/profile/upload', { formData: this.formdatas }, config).then((response) => {
        this.allDetailsPic = response.data.user_detail[0]
        localStorage.setItem('user__details', JSON.stringify(response.data.user_detail[0]))
        this.$root.$emit('cropUploadSuccess', this.allDetailsPic.profile_picture)
      })
    },
    cropUploadSuccess (jsonData, field) {
      console.log('-------- upload success --------')
      console.log(jsonData)
      console.log('field: ' + field)
      // this.$root.$emit('cropUploadSuccess', this.allDetailsPic.profile_picture)
    },
    cropUploadFail (status, field) {
      console.log('-------- upload fail --------')
      console.log(status)
      console.log('field: ' + field)
    },
    // Pan Card & AadharCard Upload
    panUpload (e) {
      this.panErrorShow = false
      console.log('connection')
      console.log(e.target.files[0])
      $('.custom-file-upload').removeClass('is-invalid')
      for (let k = 0; k < e.target.files.length; k++) {
        if (
          e.target.files[k].type === 'image/jpg' ||
          e.target.files[k].type === 'image/jpeg' || e.target.files[k].type === 'image/png'
        ) {
          if (e.target.files[k].size < '2000001') {
            this.pan.push(e.target.files[k])
          }
        }
      }
      $('#pan').val('')
      console.log(this.pan)
    },
    aadharUpload (e) {
      this.aadharErrorShow = false
      console.log(e.target.files)
      $('.custom-file-upload').removeClass('is-invalid')
      for (let k = 0; k < e.target.files.length; k++) {
        if (
          e.target.files[k].type === 'image/jpg' ||
          e.target.files[k].type === 'image/jpeg' || e.target.files[k].type === 'image/png'
        ) {
          if (e.target.files[k].size < '2000001') {
            this.aadhar.push(e.target.files[k])
          }
        }
      }
      $('#aadhar').val('')
      console.log(this.aadhar)
    },
    removePancard (index) {
      this.pan.splice(index, 1)
      console.log(this.pan)
    },
    removeAadharcard (index) {
      this.aadhar.splice(index, 1)
      console.log(this.aadhar)
    },
    panUploadFunction () {
      console.log(this.pan)
      this.user_id = localStorage.getItem('user_id')
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }
      const formData = new FormData()
      formData.append('image', this.pan[0])
      if (this.pan.length > 0) {
        axios.post(BaseURL + '/profile/add_bank_pancard/ios', formData, config)
          .then(response => {
            this.panResponse = response.data.message
            this.pancardUrl = response.data.pancard_image_location
            this.$awn.success('Pan card Uploaded Successfully')
          }, config)
          .catch(e => {
            console.log(e)
          })
      } else {
        this.panErrorShow = true
      }
    },
    aadharUploadFunction () {
      console.log(this.aadhar)
      // this.user_id = localStorage.getItem('user_id')
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }
      const formData = new FormData()
      for (let k = 0; k < this.aadhar.length; k++) {
        formData.append('image', this.aadhar[k])
      }
      if (this.aadhar.length > 0) {
        axios.post(BaseURL + '/profile/add_bank_aadharcard/ios', formData, config)
          .then(response => {
            this.aadharResponse = response.data.message
            this.aadharcardUrl = response.data.aadharcard_image_location
            this.$awn.success('AadharCard Uploaded Successfully')
          }, config)
          .catch(e => {
            console.log(e)
          })
      } else {
        this.aadharErrorShow = true
      }
    },
    submitAttachment () {
      this.panUploadFunction()
      this.aadharUploadFunction()
    },
    videoUpload (e) {
      this.videoErrorShow = false
      console.log(e.target.files)
      $('.custom-file-upload').removeClass('is-invalid')
      for (let k = 0; k < e.target.files.length; k++) {
        if (e.target.files[k].type === 'video/mp4') {
          if (e.target.files[k].size < '10000001') {
            this.showpreview = true
            this.video.push(e.target.files[k])
            const video = document.getElementById('video-preview')
            const reader = new FileReader()
            reader.readAsDataURL(e.target.files[k])
            reader.addEventListener('load', function () {
              video.src = reader.result
            })
          }
        }
      }
      $('#video').val('')
      console.log(this.video)
    },
    fileUpload (e) {
      this.fileErrorShow = false
      console.log(e.target.files)
      $('.custom-file-upload').removeClass('is-invalid')
      for (let k = 0; k < e.target.files.length; k++) {
        if (
          e.target.files[k].type ===
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
          e.target.files[k].type === 'application/pdf' ||
          e.target.files[k].type === 'application/msword'
        ) {
          if (e.target.files[k].size < '2000001') {
            this.files.push(e.target.files[k])
          }
        }
      }
      $('#file').val('')
      console.log(this.files)
    },
    removeUploading (index) {
      this.files.splice(index, 1)
      console.log(this.files)
    },
    removeVideo (index) {
      this.video.splice(index, 1)
      console.log(this.video)
      this.showpreview = false
    },
    uploading () {
      console.log(this.files)
      this.user_id = localStorage.getItem('user_id')

      const config = {
        headers: {
          'content-type': 'multipart/form-data',
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }
      const formData = new FormData()
      for (let k = 0; k < this.files.length; k++) {
        formData.append('image', this.files[k])
      }
      if (this.files.length > 0) {
        axios.post(BaseURL + '/profile/upload/certification/' + this.user_id, formData, config)
          .then(response => {
            this.resumeResponse = response.data.message
            // if (this.resumeResponse === 'Success') {
            //   this.introvideo = false
            // } else {
            //   this.isTrue = true
            // }
            this.$awn.success('Resume & Intro Video Uploaded Successfully')
          })
          .catch(e => {
            console.log(e)
          })
      } else {
        this.fileErrorShow = true
      }
    },
    videoUploading () {
      console.log(this.video)
      this.user_id = localStorage.getItem('user_id')

      const config = {
        headers: {
          'content-type': 'multipart/form-data',
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }
      const formData = new FormData()
      for (let k = 0; k < this.video.length; k++) {
        formData.append('image', this.video[k])
      }
      if (this.video.length > 0) {
        axios.post(BaseURL + '/profile/upload/video/' + this.user_id, formData, config)
          .then(response => {
            this.videoResponse = response.data.message
          }, config)
          .catch(e => {
            console.log(e)
          })
      } else {
        this.videoErrorShow = true
      }
    },
    uploadAttachment () {
      this.uploading()
      this.videoUploading()
    },
    getResume () {
      this.user_id = localStorage.getItem('user_id')
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }
      axios.get(BaseURL + '/profile/get_user_resume/' + this.user_id, config)
        .then(response => {
          this.getMyResume = response.data.resumeDetail
          console.log(this.getMyResume)
        })
        .catch(e => {
          console.log(e)
        })
    },
    getVideo () {
      this.user_id = localStorage.getItem('user_id')
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }
      axios.get(BaseURL + '/profile/get_user_resume/' + this.user_id, config)
        .then(response => {
          this.getMyintroVideo = response.data.videoDetail
          console.log(this.getMyintroVideo)
        })
        .catch(e => {
          console.log(e)
        })
    },
    changePassword () {
      this.submitted = true
      this.$v.$touch()
      if (this.form.oldpassword === this.myDatas.user_password) {
        if (this.form.newpassword === this.form.confirmPassword) {
          this.user_id = localStorage.getItem('user_id')
          const data = {
            user_id: this.user_id,
            oldpassword: this.form.oldpassword,
            newpassword: this.form.newpassword
          }
          const config = {
            headers: {
              'content-type': 'application/json',
              Authorization: 'Bearer ' + localStorage.getItem('token')
            }
          }
          axios.post(BaseURL + '/profile/change_password', { formData: data }, config)
            .then(response => {
              this.changePasswordResponse = response.data.message
              if (this.changePasswordResponse === 'Success') {
                this.$awn.success('Password Changed Successfully')
              } else {
                this.$awn.error('Password Not Changed')
              }
            }, config)
            .catch(e => {
              console.log(e)
            })
        } else {
          alert('New Password and Confirm Password does not match')
        }
      } else {
        alert('Old Password is not correct')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.rateforInterview{
  display: flex;
  flex-direction: column;
  text-align: center;
  /* justify-content: center; */
  /* text-align: center; */
  color:black;
  font-size:16px;
  list-style: none;
  font-weight: 700;
}
.btnRegister{
  background-color: #5bad2b;
  color: #fff;
}
.designation {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  align-content: flex-end;
}
.card-body {
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    min-height: 1px;
    padding: 1.25rem;
    background-color: #ffffff;
}
.rating {
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
}
.starRating{
  display: flex;
  justify-content: center;
}
#myProgress {
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: #ddd;
}
#myBar {
  width: 25%;
  height: 10px;
  background-color: #5bad2b;
}
.percentage{
  display: flex;
  justify-content: space-between;
}
.profile-user-img{
  margin: 0px auto;
    width: 130px;
    padding: 1px;
    border: 4px solid #d2d6de;
}
.img-circle {
    border-radius: 50%;
}
.myprofile {
    max-width: 240px;
    height: 130px;
}
.profileArea{
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-content: center;
  align-items: center;
}
.upload{
  background-color: #5bad2b;
  color: white;
}
.container {
  width: 100%;
  position: relative;
  margin: 0 auto;
  // background: #f5f5f5;
}
.selectyear,
.selectmonth {
  display: inline-flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: space-evenly;
}
.experience {
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  margin: 0;
}
.org {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}

.tabHeader{
  background-color: #f5f5f5;
}
.tabHeader .icon {
display: none;
}
.tabBtn>li>a {
    position: relative;
    display: block;
    // padding: 14px 27px;
    font-size: 14px;
}
.tabBtn>li.active>a, .tabBtn>li.active>a:focus, .tabBtn>li.active>a:hover {
    color: #fff;
    background-color: #5bad2b;
        border-top-color: unset;
}
.tabBtn>li>a:hover{
  color:black;
  background-color:white

}
.term {
  width: 100%;
  flex-direction: row;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  align-content: center;
}
#customers {
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  align-content: center;
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
  justify-content: center;
}

#customers td,
#customers th {
  border: 1px solid #ddd;
  padding: 8px;
}

#customers tr:nth-child(even) {
  background-color: #f2f2f2;
}

#customers tr:hover {
  background-color: #ddd;
}

#customers th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: center;
  background-color: #5bad2b;
  color: white;
}
.expyears {
  width: 40%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-content: center;
}
.star {
  display: flex;
  justify-content: center;
}
.skills {
  // column-gap: 200px;
  row-gap: 50px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  align-content: center;
}
.rating {
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
}
.accbtn {
  width: 100%;
   background-color: transparent;
   color:#5bad2b;
 }
 .accbtn:hover{
   color: white;
 }
.financialcard{
  /* From uiverse.io by @fanishah */
  display: flex;
  flex-direction: row;
  justify-content: center;
 width: 20%;
 height: 17rem;
 background-color: #f5f5f5;
 border-radius: 1rem;
//  border: #212121 0.2rem solid;
 transition: all 0.4s ease-in;
 box-shadow: 0.4rem 0.4rem 0.6rem #00000040;
}
.financialcard:hover {
opacity: 0.8;
 transform: scale(1.10);
//  border: black 0.2em solid;
 background-color: #5bad2b;

}
.accards{
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
}
.Intcost{
  font-size: 20px;
}
.editcost{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.editcostbtn{
background-color: #5bad2b;
color: white;
}
.addBankbtn{
background-color: #5bad2b;
color: white;
}
.editBankbtn{
background-color: #5bad2b;
color: white;
}
.deleteAcc{
  background-color: red;
color: white;
margin:5px
}
.transfer{
background-color: #5bad2b;
color: white;
}
.bankaccount{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: center;
  align-items: baseline;
}
.wallet{
  display: flex;
  flex-direction: row;
    justify-content: space-between;
  align-items: center;
}
.amount{
  font-size: 20px;
}
.WalletBal{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  align-content: center;
}
.withdrawbtn{
  background-color: #5bad2b;
  color: white;
}
.Transactionactivity{
  font-size: 18px;
  display: flex;
  justify-content: space-between;
}
.interview_cost {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  align-content: flex-end;
}
.skilltest {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-content: center;
  align-items: center;
  margin: 0;
  column-gap: 14px;
}
.stest{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: center;
  margin: 0px -15px;
}
.guideline{
  display: flex;
  justify-content: space-between;
}
.saveBtnCostPage{
  width:100%;
display: flex;
flex-direction: row;
justify-content: flex-end;
}
.costeditpage{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.costeditbtn{
  float: right;
  background-color: #5bad2b;
  color: white;
}
.saveaccdetialsbtn{
  background-color: #5bad2b;
  color: white;
}
.postactivities{
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  align-content: center;
}
.completed{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: center;
}
.successicon{
color: #5bad2b;
}
.declineicon{
  color:red;

}
.closeicon{
color:red;
}
.accone{
  padding: 5px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-content: center;
  align-items: baseline;
  font-size: 18px;
}
 .requesticon{
   color: #5bad2b;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   align-content: center;
 }
 .accHeadtwo{
   text-align: center;
    font-size: 16px;
 }

//  css for short intro modal
 .closebtnmodel{
   display: flex;
   flex-direction: row;
    justify-content: space-between;
    padding: 10px;
 }
 .txtarea{
   display: flex;
   flex-direction: column;
   justify-content: center;
 }
 .useravatar{
  width: 150px;
    height: 150px;
 }
 #editUserAvatar{
   width: 140px;
    height: 140px;
    margin:0px
 }
 .profileavatar{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-content: center;
    align-items: flex-start;
 }
 .workexp{
   display: flex;
   flex-direction: row;
   justify-content: space-between;
   align-content: center;
   align-items: center;
 }
 .nxtbtn {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: center;
  align-items: center;
}
.skills {
  widows: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}
.UserUpload {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.myUpload {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-top:5px
}
.MyBankData{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: center;
  align-items: center;
}
.bankdetialsdata{
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.bankform{
  display:flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}
.introBtn{
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.userName{
  color: black;
  // padding-top: 5px;
  padding-right:6px ;
}
.myProfiledata{
  padding: 5px 12.5px 12.5px 12.5px;
  // padding-top: 0%;
  background-color: white;
}
.percentageBar{
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.Statsheading{
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-content: center;
  align-items: center;
}
.myTheme{
  color: #5bad2b;
  background-color: white;
}
.videoUpload{
  padding:0%;
}
.videoPreview{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  align-items: center;
}
.iconsEdit{
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-content: center;
  align-items: center;
  width:30%
}
.attachmentUpload{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
}
.UploadBtn{
  background-color: #5bad2b;
  color: white;
}
.myUploadBtn{
    display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
}
.deleteskillmodal{
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
}
.skilltitle{
  padding: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-content: center;
}
.mybankIcon{
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-content: center;
  align-items: center;
}
.viewPanImage{
display: flex;
flex-direction: row;
justify-content: space-between;
align-content: center;
}
.viewAadharImage{
display: flex;
flex-direction: row;
justify-content: space-between;
align-content: center;
}
.changePassword{
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
}
.changemyPassword{
  // width:40%;
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  justify-content: center;

}
.exp{
    background-color: #ffffff;
    padding: 20px;
}
.intskill{
 background-color: #ffffff;
 padding: 20px;
}
.propic{
  padding-left: 30px !important;
    padding-right: 30px !important;
}
.changemypswd {
  width:40%;
}
.walbal{
   font-size: 18px;
 }
 .trans{
color:black;
background-color:#f5f5f5;
padding-top:8px;
padding-bottom:8px;
padding-left:8px;
}
.transdata{
  display: flex;
  flex-direction:row;
  justify-content: space-between;
}
.tableheader{
  font-size: 11px;
}
.tablebody{
padding: 5px;
}
.myTransTable{
width:100%
}
th {
  border: 1px solid #dddddd;
  text-align: center;
  padding: 8px;
}
td{
border-bottom:1px solid #dddddd;
text-align:center;
font-size: 12px;
padding: 6px;
}
.withdrawpopup{
  width:100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 2px;
}
// .skillsets{
//   width: 20em;
//   white-space: nowrap;
//   overflow: hidden;
//   text-overflow: ellipsis;
// }
// progress-bar{
//   width: 100%;
//   display: flex;
//   justify-content: center;
// }
// .vuejs-progress-bar{
//   display: flex;
//   width:100%;
//   height:10px;
// }
//bank account select css
   .main-container {
        width:100%;
        height: 50vh;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: row;
      }
.radio-buttons {
        display: flex;
        width: 100%;
        margin: 0 auto;
        text-align: center;
        flex-direction: row;
      }

      .custom-radio input {
        display: none;
      }

      .radio-btn {
        margin: 10px;
        width: 150px;
        height: 150px;
        border: 3px solid transparent;
        display: inline-block;
        border-radius: 10px;
        position: relative;
        text-align: center;
        box-shadow: 0 0 20px #c3c3c367;
        cursor: pointer;
      }

      .radio-btn > i {
        color: #ffffff;
        background-color: #5bad2b;
        font-size: 20px;
        position: absolute;
        top: -15px;
        left: 50%;
        transform: translateX(-50%) scale(4);
        border-radius: 50px;
        padding: 3px;
        transition: 0.2s;
        pointer-events: none;
        opacity: 0;
      }

      .radio-btn .hobbies-icon {
        width: 80px;
        height: 80px;
        position: absolute;
        top: 40%;
        left: 50%;
        transform: translate(-50%, -50%);
      }

      .radio-btn .hobbies-icon i {
        color: #5bad2b;
        line-height: 80px;
        font-size: 60px;
      }

      .radio-btn .hobbies-icon h3 {
        color: black;
        font-family: "Raleway", sans-serif;
        font-size: 14px;
        font-weight: 400;
        text-transform: uppercase;
      }

      .custom-radio input:checked + .radio-btn {
        border: 3px solid #5bad2b;
      }

      .custom-radio input:checked + .radio-btn > i {
        opacity: 1;
        transform: translateX(-50%) scale(1);
      }
      .mybankname{
        display: flex;
        text-align: center;
        flex-direction: column;
        width:100%;
        color:black;
      }
      .choosebank{
         list-style: none;
        //  display: flex;
        //  flex-direction: row;
        //   justify-content: space-evenly;
      }
//responsive css
  @media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
.tabHeader a:not(:first-child) {
    display: none;
  }
  .tabHeader a.icon {
    float: right;
    display: block;
  }
  .accbtn{
    padding:6px;
  }
  .radio-buttons {
        display: flex;
        width: 100%;
        margin: 0 auto;
        text-align: center;
        flex-direction: row;
      }
      .radio-btn {
        margin: 10px;
        width: 100px;
        height: 100px;
        border: 3px solid transparent;
        display: inline-block;
        border-radius: 10px;
        position: relative;
        text-align: center;
        box-shadow: 0 0 20px #c3c3c367;
        cursor: pointer;
      }
      .main-container {
        width:100%;
        height: 70vh;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: row;
      }
  }
  @media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
    .tabBtn{
      // padding-top: 10px;
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
      justify-content: center;
      align-content: center;
      align-items: center;
    }
    .tabBtn>li>a{
      width:100%;
    }
    .accards{
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  column-gap: 14px;
}
.tabHeader.responsive {position: relative;}
  .tabHeader.responsive .icon {
    position: absolute;
    right: 0;
    top: 0;
  }
  .tabHeader.responsive a {
    float: none;
    display: block;
    text-align: left;
  }
  #customers{
    width:90%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .exp{
    padding: 0px;
  }
  .experience {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  margin: 0;
}
.intexp{
  font-size: 16px;
}

.titleheader{
  font-size: 16px;
}
.costeditbtn{
  width: 60px;
  height: 30px;
}
.addbtn{
  width: 60px;
  height: 30px;
}
addbtn1{
  width:70px;
  height:30px;
}
.intskill{
  padding: 0px;
}
.expyears{
  width:100%;
}
.nxtbtn{
  align-items: baseline;
}
.propic{
  padding: 0px !important;
}
#myProgress {
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
align-content: center;
}
#customers td,
#customers th {
  border: 1px solid #ddd;
  padding: 4px;
}
.fa-bank,.fa-google-wallet, .fa-line-chart{
  font-size: 30px;
}
.financialcard{
  width:34%;
  height: 100px;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}
.cardname{
  font-size: 11px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;
}
.addBankbtn{
  width: 60px;
  height: 30px;
}
.mybankIcon> .fa-bank {
  font-size: 12px;
}
.accnumber{
  font-size: 12px;
  text-align: center;
}
.bankname{
  font-size: 12px;
}
.myBankBtn{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  align-items: center;
}
.editBankbtn, .deleteAcc{
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
}
.changemypswd{
  width:80%
}
.successicon, .closeicon,.declineicon
{
  font-size: 20px;
}
.iconsEdit{
  width:60%
}
.intstats{
  display: flex;
  flex-direction: row;
  }
  .intcom,
.intincom {
  display: flex;
  flex-direction: row;
  font-size: 10px;
}
.intstatistics{
  font-size: 12px;
}
.mypadding{
  padding: 0px;
}
.accHeadtwo{
    font-size: 14px;
 }
 .walbal{
   font-size: 14px;
 }
 #tabBtnRes{
   width: 100%;
   height: 45px;
   text-align: center;
   padding: 8px;
 }
 .intexp1{
  font-size: 14px;
}
.myUploadBtn{
  width:100%;
}
  }
    @media only screen and (min-device-width: 481px) and (max-device-width: 768px) {
    }
      @media only screen and (min-device-width: 769px) and (max-device-width: 1024px) {
      }
</style>
